import React, { useEffect, useRef, useState } from "react";
import { Form, Media, Card, Collapse, Row, Input, Button, Col, UncontrolledTooltip, CardBody, CardTitle, Table, Modal, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import SelectCountry from "../../components/Filter/SelectCountry";
import SelectPredictionValue from "../../components/Filter/SelectPredictionValue";
import { useFormik } from "formik";
import { Link } from "react-router-dom";
import SearchName from "../../components/Filter/SearchName";
import { useDispatch, useSelector } from "react-redux";
import {
    changePctNotifier,
    changeSearchNameList,
    changeSearchNameSelectedList,
    downloadMultiplePctExcel,
    downloadMultiplePctPdf,
    downPCtExcel,
    getPctInfo,
    getPctInfoList,
    getPctNotifierSettings,
    getPctSearchTargetGroupList,
    hidePctTarget,
    multipleHidePct,
    multipleStarPct,
    multipleUnhidePct,
    multipleUnstarPct,
    previewPctEmail,
    savePctNotifierSettings,
    sendPctEmail,
    setPctResults,
    setPctSentSuccess,
    setPctSettings,
    setPctSuccess,
    setPreviewPctEmail,
    setUpgradeAlertMessage,
    starPctTarget,
    unhidePctTarget,
    unlockPct,
    unstarPctTarget,
    setPctLoading as onSetPctLoading,
} from "../../store/actions";
import LoadingModal from "../../components/Common/LoadingModal";
import ContactsDetails from "../Contacts/ViewDetail";
import SweetAlert from "react-bootstrap-sweetalert";
import toastr from "toastr";
import _, { cloneDeep, filter, set } from "lodash";
import WeCrestPagination from "../../components/WeCrestPagination";
import EditorModal from "../../components/Common/EditorModal";
import dateFormat from 'dateformat';
import { Document, Page, pdfjs } from "react-pdf";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import styled from "styled-components";
import * as Yup from "yup";

const PDFDocumentWrapper = styled.div`
  canvas {
    width: 100% !important;
    height: auto !important;
  }
`;

let emailSentBgColor = "#ffa50069";

const normalizeRepGroupName = (repGroupName) => (repGroupName == null ? "" : String(repGroupName)).trim().toLowerCase();

const formatPctDbDate = (dateValue) => {
    if (dateValue == null || dateValue === '') {
        return '-';
    }
    const dateStr = String(dateValue);
    if (dateStr.length < 8) {
        return '-';
    }
    return `${dateStr.slice(2, 4)}/${dateStr.slice(4, 6)}/${dateStr.slice(6)}`;
};

const dedupePctRepsByGroupName = (reps) => {
    const seen = new Map();
    reps.forEach((rep, index) => {
        const key = normalizeRepGroupName(rep.repGroupName);
        if (!key) {
            seen.set(`__empty__${rep.repSeq ?? index}`, rep);
            return;
        }
        if (!seen.has(key)) {
            seen.set(key, rep);
        }
    });
    return Array.from(seen.values());
};

const PCTNotifier = () => {
    pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

    const [isOpen, setIsOpen] = useState(true);
    const [chkAllFlag, setChkAllFlag] = useState(false);
    const [starOrUnstar, setStarOrUnstar] = useState("Star");
    const [hideOrUnhide, setHideOrUnhide] = useState("Hide");
    const [confirmMsg, setConfirmMsg] = useState("");
    const [confirmAlert, setConfirmAlert] = useState(false);
    const [confirmBtnText, setConfirmBtnText] = useState("");
    const [cancelBtnText, setCancelBtnText] = useState("");
    const [alertMsg, setAlertMsg] = useState("");
    const [numPages, setNumPages] = useState(null);
    const [confirmType, setConfirmType] = useState("");
    const [pdfActiveTab, setPdfActiveTab] = useState(0);
    const [checkedLockedRowCount, setCheckedLockedRowCount] = useState(0);
    const [sendTarget, setSendTarget] = useState("");
    const [sendTargetGroupNo, setSendTargetGroupNo] = useState("");
    const [invoiceOverdueUnlockConfirmAlert, setInvoiceOverdueUnlockConfirmAlert] = useState({type: "", showYn: false})

    const dispatch = useDispatch();

    const {
        pctSettings,
        userGrade,
        loading,
        success,
        pctInfo,
        noticeStr,
        unlockCredit,
        unlockCnt,
        pctInfoTotalPages,
        result,
        previewEmail,
        previewPctPdfList,
        sentCnt,
        unsubsEmails,
        disableEmails,
        sentIn5DaysEmails,
        sentSuccess,
        upgradeAlertMessage,
        autoSearch,
        isPctSearched,
        userActiveSub,
        pctUnlockCredit,
        pctUnlockCnt,
        pctSubscription,
        pctSubscriptionInvoiceOverdueYn
    } = useSelector((state) => ({
        pctSettings: state.pctNotifier.pctSearchSettings,
        userGrade: state.pctNotifier.userGrade,
        loading: state.pctNotifier.loading,
        success: state.pctNotifier.success,
        pctInfo: state.pctNotifier.pctInfo,
        noticeStr: state.pctNotifier.noticeStr,
        unlockCredit: state.Unlock.unlockCredit,
        unlockCnt: state.Unlock.unlockCnt,
        pctInfoTotalPages: state.pctNotifier.pctInfoTotalPages,
        result: state.pctNotifier.result,
        previewEmail: state.pctNotifier.previewEmail,
        previewPctPdfList: state.pctNotifier.previewPctPdfList,
        sentCnt: state.pctNotifier.sentCnt,
        unsubsEmails: state.pctNotifier.unsubsEmails,
        disableEmails: state.pctNotifier.disableEmails,
        sentIn5DaysEmails: state.pctNotifier.sentIn5DaysEmails,
        sentSuccess: state.pctNotifier.sentSuccess,
        upgradeAlertMessage: state.pctNotifier.upgradeAlertMessage,
        autoSearch: state.pctNotifier.autoSearch,
        isPctSearched: state.pctNotifier.isPctSearched,
        userActiveSub: state.pctNotifier.userActiveSub,
        pctUnlockCredit: state.Unlock.pctUnlockCredit,
        pctUnlockCnt: state.Unlock.pctUnlockCnt,
        pctSubscription: state.Unlock.pctSubscription,
        pctSubscriptionInvoiceOverdueYn: state.Unlock.pctSubscriptionInvoiceOverdueYn,
    }));

    console.log("pctSubscriptionInvoiceOverdueYn: " + pctSubscriptionInvoiceOverdueYn)

    const dateTypeOptions = [
        { value: "PBD", label: "Publication Date" },
        { value: "IFD", label: "International Filing Date" },
        { value: "EPD", label: "Earliest Priority Date" },
        { value: "EVD", label: "National phase entry date" },
        { value: "EPD=IFD", label: "Earliest Priority Date = International Filing Date" },
        { value: "EPD+12", label: "Earliest Priority Date + 12 months" },
        { value: "EPD+19", label: "Earliest Priority Date + 19 months" },
        { value: "EPD+20", label: "Earliest Priority Date + 20 months" },
        { value: "EPD+21", label: "Earliest Priority Date + 21 months" },
        { value: "EPD+22", label: "Earliest Priority Date + 22 months" },
        { value: "EPD+23", label: "Earliest Priority Date + 23 months" },
        { value: "EPD+24", label: "Earliest Priority Date + 24 months" },
        { value: "EPD+25", label: "Earliest Priority Date + 25 months" },
        { value: "EPD+26", label: "Earliest Priority Date + 26 months" },
        { value: "EPD+27", label: "Earliest Priority Date + 27 months" },
        { value: "EPD+28", label: "Earliest Priority Date + 28 months" },
        { value: "EPD+29", label: "Earliest Priority Date + 29 months" },
        { value: "EPD+30", label: "Earliest Priority Date + 30 months" },
        { value: "EPD+31", label: "Earliest Priority Date + 31 months" },
        { value: "EPD+32", label: "Earliest Priority Date + 32 months" },
        { value: "EPD+33", label: "Earliest Priority Date + 33 months" },
        { value: "EPD+34", label: "Earliest Priority Date + 34 months" },
        { value: "EPD+35", label: "Earliest Priority Date + 35 months" },
        { value: "EPD+36", label: "Earliest Priority Date + 36 months" },
        { value: "EPD+37", label: "Earliest Priority Date + 37 months" },
        { value: "EPD+38", label: "Earliest Priority Date + 38 months" },
        { value: "EPD+39", label: "Earliest Priority Date + 39 months" },
        { value: "EPD+40", label: "Earliest Priority Date + 40 months" },
        { value: "EPD+41", label: "Earliest Priority Date + 41 months" },
        { value: "EPD+42", label: "Earliest Priority Date + 42 months" },
        { value: "UPD", label: "Uploaded date" },
    ]

    const [columns, setColumns] = useState([
        {
            id: "email",
            label: "Email",
            asc: null,
            desc: null,
            ascActive: null,
            descActive: null,
            tooltip: null,
            style: {},
            minWidth: "60px"
        },
        {
            id: "agent",
            label: "Agent",
            asc: "REA",
            desc: "RED",
            ascActive: "",
            descActive: "",
            tooltip: null,
            style: { marginLeft: '3rem' },
            minWidth: "100px"
        },
        {
            id: "holder",
            label: "Holder",
            asc: "HOA",
            desc: "HOD",
            ascActive: "",
            descActive: "",
            tooltip: null,
            style: { marginLeft: '3rem' },
            minWidth: "100px"
        },
        {
            id: "applicationNo",
            label: "Application\nno",
            asc: "ANA",
            desc: "AND",
            ascActive: "",
            descActive: "",
            tooltip: null,
            style: { marginLeft: '4.2rem' },
            minWidth: "60px"
        },
        {
            id: "earliestPriorityDate",
            label: "Earliest\npriority\ndate",
            asc: "EDA",
            desc: "EDD",
            ascActive: "",
            descActive: "text-danger",
            tooltip: null,
            style: { marginLeft: '2.5rem' },
            minWidth: "60px"
        },
        {
            id: "internationalFilingDate",
            label: "International\nfiling\ndate",
            asc: "IDA",
            desc: "IDD",
            ascActive: "",
            descActive: "",
            tooltip: null,
            style: { marginLeft: '5.15rem' },
            minWidth: "60px"
        },
        {
            id: "pubDate",
            label: "Publication\ndate",
            asc: "PDA",
            desc: "PDD",
            ascActive: "",
            descActive: "",
            tooltip: null,
            style: { marginLeft: '5.15rem' },
            minWidth: "60px"
        },
        {
            id: "npe",
            label: "National\nphase\nentries",
            asc: "",
            desc: "",
            ascActive: "",
            descActive: "",
            tooltip: null,
            style: { marginLeft: '5.15rem' },
            minWidth: "60px"
        },
        {
            id: "npeLikelihood",
            label: "NPE\nlikelihood\n",
            asc: "NRA",
            desc: "NRD",
            ascActive: "",
            descActive: "",
            tooltip: "Prediction percentage is calculated based on how many of the holder’s"
            +" 100 most recent PCT applications entered the national phase in this jurisdiction." 
            +"If there were less than 100 cases in the last 10 years, then all cases from the last 10 years were used for the calculation.",
            style: {},
            minWidth: "60px"
        },
        {
            id: "wecrestSendCount",
            label: "WeCrest send count\nToday\n(Total)",
            asc: null,
            desc: null,
            ascActive: null,
            descActive: null,
            tooltip: "Number of WeCrest members who sent emails from WeCrest for this case. (This does not include the number of members who unlocked this case.)"
                + " No more than five members per day can send an email for the same case and the send count resets daily."
                + " Members are required to wait five days before sending another email for the same case.",
            style: {},
            minWidth: "60px"
        },

    ])

    const errMsg = [
        <span>You are one small step away from being able to use the PCT Notifier. Please complete the setup process by entering your email settings <a href='/settings#subscriptionSettings'>here</a>. Once you have completed this step, you will be able to send emails using the PCT Notifier.</span>
        , "Please select a case."
        , <span>Your email is blank. Please edit your email or select a template in your <a href='/settings#emailTemplateSetting'>Settings.</a></span>
        , "Sorry, unfortunately you do not have any credits remaining. Get more credits and connect with more clients."
        , "Not enough credits remaining"
        , "Unlocking is not possible for this case. The sending limit of 5 emails has been reached already."
        , "Please select cases to unlock"
        , "Unlock Fail!"
        , "Select up to 50 cases to download a report in PDF format"
        , "Email sending is not possible for this case. The sending limit of 5 emails has been reached already."
        , "There is no contact information for the selected case."
        , "Emails have been sent for the selected cases in the last 5 days."
        , "From date is required" // 13
        , "To date is required" // 14
        , "From date must be earlier than to date" // 15
        , "Please select at least one National phase country/region to use the National phase entry date filter." // 16
    ];

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    //today - 5 days in YYYY-MM-DD format
    const todayMinus5Str = new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString().split("T")[0];
    //today + 91 days in YYYY-MM-DD format
    const todayPlus91Str = new Date(Date.now() + 91 * 24 * 60 * 60 * 1000).toISOString().split("T")[0];
    //today + 121 days in YYYY-MM-DD format
    const todayPlus121Str = new Date(Date.now() + 121 * 24 * 60 * 60 * 1000).toISOString().split("T")[0];


    const toggle = () => {
        setIsOpen(!isOpen);
    }

    const setPctLoading = () => {
        dispatch(onSetPctLoading(!loading))
    }

    const pctValidation = useFormik({
        enableReinitialize: true,
        initialValues: {
            repType: pctSettings && pctSettings.repType ? pctSettings.repType : 'All',
            repCdList: pctSettings && pctSettings.repCdList ? pctSettings.repCdList : [],
            holderType: pctSettings && pctSettings.holderType ? pctSettings.holderType : 'All',
            holderCdList: pctSettings && pctSettings.holderCdList ? pctSettings.holderCdList : [],
            searchKeyword: pctSettings && pctSettings.searchKeyword ? pctSettings.searchKeyword : '',
            searchNameList: [],
            searchNoList: pctSettings && pctSettings.groupNoList ? pctSettings.groupNoList : [],
            pubNumber: pctSettings && pctSettings.pubNumber ? pctSettings.pubNumber : '',
            dateType: pctSettings && pctSettings.dateType ? pctSettings.dateType : 'EPD+30',
            // when dateType includes "EPD+Number" derive the number of months from it
            // epdMonth: pctSettings && pctSettings.dateType.includes("EPD+") ? pctSettings.dateType.parseInt(str.match(/\d+/)[0], 10) : '19',
            fromDate: pctSettings && pctSettings.fromDate ? pctSettings.fromDate : todayPlus91Str,
            toDate: pctSettings && pctSettings.toDate ? pctSettings.toDate : todayPlus121Str,
            sendCount: pctSettings && pctSettings.sendCount ? pctSettings.sendCount : userActiveSub > 0 ? "opt0" : 'optAll',
            entityStatus: pctSettings && pctSettings.entityStatus ? pctSettings.entityStatus : userActiveSub > 0 ? 'ONH' : 'ALL',
            hasRep: pctSettings && pctSettings.hasRep ? pctSettings.hasRep : 'ALL',
            emailSent: pctSettings && pctSettings.emailSent ? pctSettings.emailSent : 'NO',
            caseVisibility: pctSettings && pctSettings.caseVisibility ? pctSettings.caseVisibility : 'All',
            npeCdList: pctSettings && pctSettings.npeCdList ? pctSettings.npeCdList : [],
            noNpeYn: pctSettings && pctSettings.noNpeYn ? pctSettings.noNpeYn : 'N',
            npePredictionCr: pctSettings && pctSettings.npePredictionCr ? pctSettings.npePredictionCr : "",
            npePredictionNo: pctSettings && pctSettings.npePredictionNo ? pctSettings.npePredictionNo : null,
            screenName: 'PCTNotifier',
            sortType: "EDD",
            pageSize: 50,
            curPage: 1,
        },

        validationSchema: Yup.object().shape({
            /* fromDate: Yup.date()
               .required("Please Select From date")
               .when('toDate', (toDate, schema) => {
                 return toDate
                   ? schema.max(toDate, "From date must be earlier than to date")
                   : schema;
               }),

             toDate: Yup.date()
               .required("Please Select to date"), */
        }),
        validateOnChange: false,
        validateOnBlur: false,

        onSubmit: (values) => {

            let submitType = values["submitType"];

            if (["view", "downExcel", "Pdf", "saveSettings"].includes(submitType)) {
                // console.log("true")
                const startDate = values["fromDate"] // yyyy-mm-dd
                const endDate = values["toDate"] // yyyy-mm-dd
                if (!startDate) {
                    dispatch(setPctResults(12)); return false;
                } else if (!endDate) {
                    dispatch(setPctResults(13)); return false;
                } else if (new Date(startDate) > new Date(endDate)) {
                    dispatch(setPctResults(14)); return false;
                }
            }

            if (["view", "downExcel"].includes(submitType)) {
                if (values["dateType"] === "EVD" && (!values["npeCdList"] || values["npeCdList"].length === 0)) {
                    dispatch(setPctResults(15)); return false;
                }
            }

            const npePredictionNo = values["npePredictionNo"];
            if (npePredictionNo !== '' && npePredictionNo != null && !/^\d+$/.test(String(npePredictionNo))) {
                pctValidation.setFieldError('npePredictionNo', 'Invalid input. Please enter a whole number');
                return false;
            }

            if (values["holderType"] === 'Individual' && (values["holderCdList"] === '' || values["holderCdList"].length === 0)) {
                values["holderType"] = 'All';
            }
            if (values["repType"] === 'Individual' && (values["repCdList"] === '' || values["repCdList"].length === 0)) {
                values["repType"] = 'All';
            }

            const filterParam = {
                repCdList: values["repCdList"],
                repType: values["repType"],
                holderCdList: values["holderCdList"],
                holderType: values["holderType"],
                searchKeyword: values["searchKeyword"],
                searchNameList: values["searchNameList"],
                groupNoList: values["searchNoList"],
                pubNumber: values["pubNumber"],
                dateType: values["dateType"],
                fromDate: values["fromDate"],
                toDate: values["toDate"],
                sendCount: values["sendCount"],
                entityStatus: values["entityStatus"],
                hasRep: values["hasRep"],
                caseVisibility: values["caseVisibility"],
                emailSent: values["emailSent"],
                sortType: values["sortType"],
                pageSize: values["pageSize"],
                curPage: values["curPage"],
                npeCdList: values["npeCdList"],
                noNpeYn: values["noNpeYn"],
                npePredictionCr: values["npePredictionCr"],
                npePredictionNo: values["npePredictionNo"],
            }

            let fileName = dateFormat(new Date(), "yymmdd") + " WeCrest PCT Notifier (" + values["fromDate"].replace(/-/gi, "") + "-" + values["toDate"].replace(/-/gi, "") + ")";

            if (submitType === "saveSettings") {
                // console.log("filterParam>>>>>>>>>"+JSON.stringify(filterParam))
                dispatch(savePctNotifierSettings(filterParam));
            } else if (submitType === "view") {
                // console.log("pctinfo>>>>>>>>>"+JSON.stringify(pctInfo))
                // console.log("userActiveSub", userActiveSub);
                // console.log("pctSettings", pctSettings);
                // console.log("filterParam", filterParam);
                dispatch(getPctInfo(filterParam));
            } else if (submitType === 'Hide') {
                const _pctNotifier = [];
                pctInfo.map((row, index) => {
                    if (row.checked === true && row.hideYn === 'N') {
                        _pctNotifier.push(row);
                    }
                })
                dispatch(multipleHidePct(_pctNotifier));
                setStarOrUnstar("Star");
                setHideOrUnhide("Hide");
            } else if (submitType === 'Unhide') {
                const _pctNotifier = [];
                pctInfo.map((row, index) => {
                    if (row.checked === true && row.hideYn === 'Y') {
                        _pctNotifier.push(row);
                    }
                })
                dispatch(multipleUnhidePct(_pctNotifier));
                setStarOrUnstar("Star");
                setHideOrUnhide("Hide");
            } else if (submitType === 'Star') {
                const _pctNotifier = [];
                pctInfo.map((row, index) => {
                    if (row.checked === true && row.starYn === 'N') {
                        _pctNotifier.push(row);
                    }
                })
                // console.log(_pctNotifier)
                dispatch(multipleStarPct(_pctNotifier));
                setStarOrUnstar("Star");
                setHideOrUnhide("Hide");
            } else if (submitType === 'Unstar') {
                const _pctNotifier = [];
                pctInfo.map((row, index) => {
                    if (row.checked === true && row.starYn === 'Y') {
                        _pctNotifier.push(row);
                    }
                })
                dispatch(multipleUnstarPct(_pctNotifier));
                setStarOrUnstar("Star");
                setHideOrUnhide("Hide");
            } else if (submitType.indexOf("unlock_") === 0) {
                let idx = submitType.replace("unlock_", "");
                const _pctNotifier = [];
                _pctNotifier.push(pctInfo[idx]);

                dispatch(unlockPct({ pctNotifierList: _pctNotifier }))
            } else if (submitType === 'multipleUnlock') {
                const _pctNotifier = []
                pctInfo.map((row, index) => {
                    if (row.checked && row.unlockYn === 'N') {
                        _pctNotifier.push(row)
                    }
                })
                if (_pctNotifier.length > 0) {
                    dispatch(unlockPct({ pctNotifierList: _pctNotifier }))
                } else {
                    dispatch(setPctResults(6))
                }
            } else if (submitType === 'downExcel') {
                dispatch(downPCtExcel(filterParam, fileName));
            } else if (submitType === 'multipleExcel') {
                // console.log("download")
                const _pctNotifier = [];
                pctInfo.map((row, index) => {
                    if (row.checked === true) {
                        _pctNotifier.push(row);
                    }
                })
                dispatch(downloadMultiplePctExcel({ pctNotifierList: _pctNotifier }, fileName));
            } else if (submitType === 'multiplePdf') {
                const _pctNotifier = [];
                pctInfo.map((row, index) => {
                    if (row.checked === true) {
                        _pctNotifier.push(row);
                    }
                })

                if (_pctNotifier.length > 50) {
                    dispatch(setPctResults(8))
                } else {
                    const param = {
                        holderCdList: values["holderCdList"],
                        holderType: values["holderType"],
                        repCdList: values["repCdList"],
                        repType: values["repType"],
                        searchNameList: values["searchNameList"],
                        pubNumber: values["pubNumber"].trim(),
                        fromDate: values["fromDate"],
                        toDate: values["toDate"],
                        pctNotifierList: _pctNotifier,
                        npeCdList: values["npeCdList"],
                        noNpeYn: values["noNpeYn"],
                        npePredictionCr: values["npePredictionCr"],
                        npePredictionNo: values["npePredictionNo"],
                    }
                    dispatch(downloadMultiplePctPdf(param, fileName));
                }
            } else if (submitType === 'multipleSend') {
                const _pctNotifier = []
                pctInfo.map((row, index) => {
                    if (row.checked === true) {
                        _pctNotifier.push(row);
                    }
                });

                dispatch(sendPctEmail({ pctNotifierList: _pctNotifier, sendTarget: sendTarget }))
            } else if (submitType.indexOf("send_") === 0) {
                if (sendTarget === 'REP') {
                    let idx = submitType.replace("send_", "");
                    const _pctNotifier = [];
                    _pctNotifier.push(pctInfo[idx]);
                    dispatch(sendPctEmail({ pctNotifierList: _pctNotifier, sendTarget: sendTarget }))
                } else if (sendTarget === 'HOL') {
                    // console.log("HOL"+submitType)
                    let idx = submitType.replace("send_", "");
                    const _pctNotifier = [];
                    _pctNotifier.push(pctInfo[idx]);
                    // console.log("send target" + idx)
                    dispatch(sendPctEmail({ pctNotifierList: _pctNotifier, sendTarget: sendTarget, sendTargetGroupNo: sendTargetGroupNo }))
                } else {
                    //   console.log("error")
                }
            }
        }

    });

    useEffect(() => {
        window.addEventListener('click', handleClosePctModal);

        if (localStorage.getItem("pctFilterParam") && localStorage.getItem("searchPctNameList")) {
            dispatch(getPctSearchTargetGroupList({ targetGroupNo: JSON.parse(localStorage.getItem("searchPctNameList"))[0].no }));
            dispatch(setPctSettings({ pctSearchSettings: JSON.parse(localStorage.getItem("pctFilterParam")) }));
            localStorage.removeItem("pctFilterParam");
            localStorage.removeItem("searchPctNameList");
        } else {
            dispatch(getPctNotifierSettings());
        }

        return () => {
            window.removeEventListener('click', handleClosePctModal);
        };
    }, []);

    useEffect(() => {
        if (success) {
            dispatch(getPctNotifierSettings());
        }
    }, [success]);

    useEffect(() => {
        if (isPctSearched && pctValidation.values.searchNoList.length > 0) {
            pctValidation.setFieldValue("submitType", "view");
            pctValidation.handleSubmit(pctValidation.values);
        }
    }, [pctValidation.values.searchNoList]);

    useEffect(() => {
        if (autoSearch == 'Y') {
            setTimeout(function () {
                //   toggle();
                pctValidation.setFieldValue("submitType", "view");
                pctValidation.handleSubmit(pctValidation.values);
            }, 100);
        }

    }, [autoSearch])

    const unsecuredCopyToClipboard = (text, elmentId) => {
        const textArea = document.createElement("textarea");
        textArea.setAttribute("type", "hidden");
        textArea.value = text;

        // const node = document.getElementById(elmentId).lastElementChild;
        document.getElementById(elmentId).appendChild(textArea);
        // document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            document.execCommand("copy");
        } catch (err) {
            //   console.error("Unable to copy to clipboard", err);
        }
        document.getElementById(elmentId).removeChild(textArea);
    };

    function showSuccessCopyToast() {
        const ele = "success";
        const position = "toast-bottom-left";
        const title = "";
        let message = "Copy clipboard!";

        //Close Button
        const closeButton = false;

        //Debug
        const debug = false;

        //Progressbar
        const progressBar = false;

        //Duplicates
        const preventDuplicates = false;

        //Newest on Top
        const newestOnTop = false;

        //position class
        let positionClass = "toast-bottom-left";

        //Show Easing
        const showEasing = "swing";

        //Hide Easing
        const hideEasing = "linear";

        //show method
        const showMethod = "fadeIn";

        //Hide method
        const hideMethod = "fadeOut";

        //show duration
        const showDuration = 300;

        //Hide duration
        const hideDuration = 1000;

        //timeout
        const timeOut = 1000;

        //extended timeout
        const extendedTimeOut = 1000;

        toastr.options = {
            positionClass: positionClass,
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: closeButton,
            debug: debug,
            progressBar: progressBar,
            preventDuplicates: preventDuplicates,
            newestOnTop: newestOnTop,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,
            hideDuration: hideDuration,
        };

        // setTimeout(() => toastr.success(`Settings updated `), 300)
        //Toaster Types
        toastr.success(message, title);
    }

    const viewPctNotifier = (sortType, curPage, pageSize) => {
        if (curPage) {
            if (curPage > pctInfoTotalPages) {
                curPage = pctInfoTotalPages;
            } else if (curPage <= 0) {
                curPage = 1;
            }
        }

        if (sortType) {
            const _columns = [];
            columns.map((col, index) => {
                let _col = cloneDeep(col);
                if (col.asc && col.asc === sortType) {
                    _col.ascActive = "text-danger";
                    _col.descActive = "";
                } else if (col.desc && col.desc === sortType) {
                    _col.ascActive = "";
                    _col.descActive = "text-danger";
                } else {
                    _col.ascActive = "";
                    _col.descActive = "";
                }
                _columns.push(_col);
            });

            setColumns(_columns);
        }

        pctValidation.setFieldValue("submitType", "view");
        if (sortType) {
            pctValidation.setFieldValue("sortType", sortType);
        }
        if (curPage) {
            pctValidation.setFieldValue("curPage", curPage);
            setCurPageInput(curPage);
        } else {
            pctValidation.setFieldValue("curPage", 1);
            setCurPageInput(1);
        }
        if (pageSize) {
            pctValidation.setFieldValue("pageSize", pageSize);
        }

        pctValidation.handleSubmit(pctValidation.values);
    }

    const [lastClickedIdx, setLastClickedIdx] = useState(-1);
    const [selectedCaseCount, setSelectedCaseCount] = useState(0);
    const rowCheck = (str, e) => {
        let chkCnt = 0;
        var hiddenCaseCnt = 0;
        var starCaseCnt = 0;
        var lockedCaseCnt = 0;

        let checked = e.target.checked;
        let shift = e.shiftKey;
        let ctrlOrCmd = e.ctrlKey || e.metaKey;

        const _pctNotifier = [];
        pctInfo.map((row, index) => {
            let _row = cloneDeep(row);

            if (str === "chkAll") {
                _row.checked = checked;
            } else if (shift && ctrlOrCmd && lastClickedIdx != -1) {
                const start = Math.min(str, lastClickedIdx);
                const end = Math.max(str, lastClickedIdx);
                if (index >= start && index <= end) {
                    _row.checked = checked;
                }
            } else if (str === index) {
                _row.checked = checked;
            }

            if (_row.checked === true) {
                chkCnt++;
                if (row.hideYn === 'Y') {
                    hiddenCaseCnt++;
                }
                if (row.starYn === 'Y') {
                    starCaseCnt++;
                }
                if (row.unlockYn === 'N') {
                    lockedCaseCnt++;
                }
            }

            _pctNotifier.push(_row);
            // console.log("rowcheck", _row.pubNumber, _row.checked);
        });

        if (chkCnt !== 0 && chkCnt === hiddenCaseCnt) {
            setHideOrUnhide("Unhide");
        } else {
            setHideOrUnhide("Hide");
        }

        if (chkCnt !== 0 && chkCnt === starCaseCnt) {
            setStarOrUnstar("Unstar");
        } else {
            setStarOrUnstar("Star");
        }

        if (pctInfo.length === chkCnt) {
            setChkAllFlag(true);
        } else {
            setChkAllFlag(false);
        }

        if (str != "chkAll") setLastClickedIdx(str);
        else setLastClickedIdx(-1);

        setSelectedCaseCount(chkCnt)
        setCheckedLockedRowCount(lockedCaseCnt);
        dispatch(changePctNotifier(_pctNotifier));
    }

    useEffect(() => {
        setLastClickedIdx(-1)
    }, [pctValidation.values.submitType])

    useEffect(() => {
        if (Object.keys(previewPctPdfList).length > 0) {
            // console.log("previewPctPdfList", previewPctPdfList)
            // console.log("pdfActiveTab", pdfActiveTab)
            // console.log("Object.keys(previewPctPdfList)", Object.keys(previewPctPdfList))
            // console.log("Object.keys(previewPctPdfList).sort", Object.keys(previewPctPdfList).sort((a, b) => a.localeCompare(b)))
            setPdfActiveTab(Object.keys(previewPctPdfList).sort((a, b) => a.localeCompare(b))[0]);
        }
    }, [previewPctPdfList])

    const caseChk = () => {
        const _pctNotifier = [];
        pctInfo.map((row, index) => {
            if (row.checked === true) {
                _pctNotifier.push(row);
                // console.log("casecheck", row.pubNumber, row.checked);
            }
        });

        if (_pctNotifier.length === 0) {

            dispatch(setPctResults(1));
            return false;
        }
        return true;
    }

    //pagination
    const [curPageInput, setCurPageInput] = useState(1);

    const viewList = (sortType, curPage, pageSize) => {

        if (curPage) {
            if (curPage > pctInfoTotalPages) {
                curPage = pctInfoTotalPages;
            } else if (curPage <= 0) {
                curPage = 1;
            }
        }

        pctValidation.setFieldValue("submitType", "view");

        if (curPage) {
            pctValidation.setFieldValue("curPage", curPage);
            setCurPageInput(curPage);
        } else {
            pctValidation.setFieldValue("curPage", 1);
            setCurPageInput(1);
        }
        if (pageSize) {
            pctValidation.setFieldValue("pageSize", pageSize);
        }
        if (sortType) {
            pctValidation.setFieldValue("sortType", sortType);
        }
        pctValidation.handleSubmit(pctValidation.values);
    }

    //contact screen
    const [modalContactsScreen, setModalContactsScreen] = useState(false);
    const [contactsTargetGroupNo, setContactsTargetGroupNo] = useState({ targetGroupNo: 0, targetGroupCountry: null, targetGroupAddress: null });
    const [contactsRepList, setContactsRepList] = useState(null);

    function togContactsScreen(targetGroupNo, repList, targetGroupCountry, targetGroupAddress) {
        // console.log("targetGroupNo", targetGroupNo);
        if (targetGroupNo) {
            // console.log(">>> [pctn]rep list: ", repList)
            // console.log(">>> [pctn]targetGroupNo: ", targetGroupNo)

            if (repList) {
                const currentRep = repList.find(
                    (rep) => rep.repGroupNo != null && String(rep.repGroupNo) === String(targetGroupNo)
                );
                const currentGroupName = normalizeRepGroupName(currentRep?.repGroupName);
                const otherReps = repList.filter(
                    (rep) => !currentGroupName || normalizeRepGroupName(rep.repGroupName) !== currentGroupName
                );
                const uniqueOtherReps = dedupePctRepsByGroupName(otherReps);
                if (uniqueOtherReps.length > 0) {
                    setContactsRepList(uniqueOtherReps)
                } else {
                    setContactsRepList(null)
                }
            } else {
                setContactsRepList(null)
            }
            setContactsTargetGroupNo({ targetGroupNo: targetGroupNo, targetGroupCountry: targetGroupCountry, targetGroupAddress: targetGroupAddress });

            // console.log("targetNo TRUE " + targetGroupNo);
        } else {
            setContactsTargetGroupNo({ targetGroupNo: 0, targetGroupCountry: null, targetGroupAddress: null });
            setContactsRepList(null)

            // console.log("contactsTargetGroupNo", contactsTargetGroupNo);
            const _pctNotifier = [];
            pctInfo.map((row, index) => {
                row.holderList.map((holder, holIndex) => {
                    if (holder.holGroupNo == contactsTargetGroupNo.targetGroupNo) {
                        _pctNotifier.push(row);
                    }
                });
                row.repList.map((rep, repIndex) => {
                    if (rep.repGroupNo == contactsTargetGroupNo.targetGroupNo) {
                        _pctNotifier.push(row);
                    }
                })
            });

            if (_pctNotifier.length > 0) {
                dispatch(getPctInfoList(_pctNotifier));
            }
        }

        setModalContactsScreen(!modalContactsScreen);
    }

    // Editor
    const [isOpenEditor, setIsOpenEditor] = useState(false);
    const [isInitEditor, setIsInitEditor] = useState(false);
    const [loadedEditor, setLoadedEditor] = useState(false);
    const [pubNumber, setPubNumber] = useState(-1);
    const [earliestPriorityDate, setEarliestPriorityDate] = useState("");
    const [editedTemplateYn, setEditedTemplateYn] = useState("N");

    function openEditor(pubNumber, pctEmailTmpSetYn, earlpriorityDate, availableDocTypes) {
        if (!isInitEditor) {
            setIsInitEditor(true);
        }

        localStorage.setItem("pctReloadParam", JSON.stringify({ pubNumber: pubNumber, earlpriorityDate: earlpriorityDate, availableDocTypes: availableDocTypes }));

        setPubNumber(pubNumber);
        setEarliestPriorityDate(earlpriorityDate);
        setEditedTemplateYn(pctEmailTmpSetYn);
        setIsOpenEditor(true);
        addBodyCss();
    }

    function closeEditor() {
        const reloadParam = JSON.parse(localStorage.getItem("pctReloadParam"));
        dispatch(getPctInfoList([{ pubNumber: reloadParam.pubNumber }]));
        localStorage.removeItem("pctReloadParam");

        setIsOpenEditor(false);
        setPubNumber(-1);

        if (editorModaRef.current) {
            editorModaRef.current.clearEditorContent();
        }

        removeBodyCss();
    }

    function removeBodyCss() {
        document.body.classList.remove("no_padding");
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "visible";
        document.body.style.paddingRight = "";

        // console.log("removeBodyCss>>");
    }

    function addBodyCss() {
        document.body.classList.add("no_padding");
        document.body.classList.add("modal-open");
        document.body.style.overflow = "hidden";
    }

    const editorModaRef = useRef(null);
    const editorModal = useRef(null);
    const handleClosePctModal = (e) => {
        if (e.target.id === 'EditorModal' && (!editorModal.current || !editorModal.current.contains(e.target))) {
            closeEditor()
        }
    }

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    return (
        <React.Fragment>
            <Form onSubmit={pctValidation.handleSubmit}>
                <div className="page-content">
                    <div className="container-fluid">
                        <Card>
                            <Link onClick={toggle} className="text-dark" to="#">
                                <div className="p-4">
                                    <Media className="d-flex align-items-center">
                                        <div className="flex-shrink-0 me-3">
                                            <i className="uil uil-file-alt text-primary h2"></i>
                                        </div>
                                        <div className="flex-grow-1 overflow-hidden">
                                            <h5 className="font-size-16 mb-1">PCT Notifier</h5>
                                            <p className="text-muted mb-0">Use this tool to connect with agents or holders whose national phase entry deadline is coming up soon.</p>
                                        </div>
                                        <i className="uil uil-filter font-size-24 text-muted"></i>
                                    </Media>
                                </div>
                            </Link>
                            <Collapse isOpen={isOpen}>
                                <div className="p-4 border-top">
                                    <div>
                                        <SelectCountry
                                            componentName='Agent'
                                            formik={pctValidation}
                                        />
                                        <SelectCountry
                                            componentName='Holder'
                                            formik={pctValidation}
                                        />
                                        <SearchName
                                            formik={pctValidation}
                                            labelName="Name of agent or holder"
                                        />
                                        <SelectCountry
                                            componentName='Npe'
                                            formik={pctValidation}
                                        />
                                        <SelectPredictionValue
                                            componentName='NpePrediction'
                                            formik={pctValidation}
                                        />
                                        <Row className="mb-3">
                                            <label className="col-md-3 col-form-label">Case number</label>
                                            <div className="col-md-6">
                                                <input
                                                    name="pubNumber"
                                                    id="pubNumber"
                                                    type="text"
                                                    className="custom-select form-control"
                                                    placeholder="Enter application or publication number(e.g. WO/2025/011234 or WO2025011234)"
                                                    value={pctValidation.values.pubNumber}
                                                    onChange={pctValidation.handleChange}
                                                />
                                            </div>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3 col-form-label" style={{ paddingTop: '0px' }}>
                                                <select
                                                    className="col-md-3 form-select"
                                                    name="dateType"
                                                    id="dateType"
                                                    value={pctValidation.values.dateType}
                                                    onChange={pctValidation.handleChange}
                                                >
                                                    {dateTypeOptions.map((option, index) => {
                                                        return (
                                                            <option key={index} value={option.value}>{option.label}</option>
                                                        )
                                                    })}
                                                </select>
                                            </label>
                                            <label className="col-md-1 col-form-label">From</label>
                                            <div className="col-md-2">
                                                <Input
                                                    name="fromDate"
                                                    id="fromDate"
                                                    type="date"
                                                    className="form-control"
                                                    value={pctValidation.values.fromDate}
                                                    onChange={pctValidation.handleChange}
                                                ></Input>
                                                {pctValidation.errors.fromDate && (<div className="text-danger">{pctValidation.errors.fromDate}</div>)}
                                            </div>
                                            <label className="col-md-1 col-form-label">To</label>
                                            <div className="col-md-2">
                                                <Input
                                                    name="toDate"
                                                    id="toDate"
                                                    type="date"
                                                    className="form-control"
                                                    value={pctValidation.values.toDate}
                                                    onChange={pctValidation.handleChange}
                                                ></Input>
                                                {pctValidation.errors.toDate && (<div className="text-danger">{pctValidation.errors.toDate}</div>)}
                                            </div>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3 col-form-label">
                                                Send count
                                            </label>
                                            <div className="col-md-1 form-check">
                                                <input type="radio" className="form-check-input"
                                                    name="sendCount"
                                                    id="sendCount0"
                                                    value="opt0"
                                                    checked={pctValidation.values.sendCount === "opt0"}
                                                    onChange={pctValidation.handleChange}
                                                ></input>
                                                <label className="form-check-label" htmlFor="sendCount0">0</label>
                                            </div>
                                            <div className="col-md-1 form-check">
                                                <input type="radio" className="form-check-input"
                                                    name="sendCount"
                                                    id="sendCount1-3"
                                                    value="opt1-3"
                                                    checked={pctValidation.values.sendCount === "opt1-3"}
                                                    onChange={pctValidation.handleChange}
                                                ></input>
                                                <label className="form-check-label" htmlFor="sendCount1-3">1-3</label>
                                            </div>
                                            <div className="col-md-1 form-check">
                                                <input type="radio" className="form-check-input"
                                                    name="sendCount"
                                                    id="sendCount4-9"
                                                    value="opt4-9"
                                                    checked={pctValidation.values.sendCount === "opt4-9"}
                                                    onChange={pctValidation.handleChange}
                                                ></input>
                                                <label className="form-check-label" htmlFor="sendCount4-9">4-9</label>
                                            </div>
                                            <div className="col-md-1 form-check">
                                                <input type="radio" className="form-check-input"
                                                    name="sendCount"
                                                    id="sendCount10-20"
                                                    value="opt10-20"
                                                    checked={pctValidation.values.sendCount === "opt10-20"}
                                                    onChange={pctValidation.handleChange}
                                                ></input>
                                                <label className="form-check-label" htmlFor="sendCount10-20">10-20</label>
                                            </div>
                                            <div className="col-md-1 form-check">
                                                <input type="radio" className="form-check-input"
                                                    name="sendCount"
                                                    id="sendCount20+"
                                                    value="opt20+"
                                                    checked={pctValidation.values.sendCount === "opt20+"}
                                                    onChange={pctValidation.handleChange}
                                                ></input>
                                                <label className="form-check-label" htmlFor="sendCount20+">20+</label>
                                            </div>
                                            <div className="col-md-1 form-check">
                                                <input type="radio" className="form-check-input"
                                                    name="sendCount"
                                                    id="sendCountAll"
                                                    value="optAll"
                                                    checked={pctValidation.values.sendCount === "optAll"}
                                                    onChange={pctValidation.handleChange}
                                                ></input>
                                                <label className="form-check-label" htmlFor="sendCountAll">All</label>
                                            </div>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3 col-form-label">
                                                Case access
                                            </label>
                                            <div className="col-md-2 form-check">
                                                <input type="radio" className="form-check-input"
                                                    name="caseVisibility"
                                                    id="unlocked"
                                                    value="Unlocked"
                                                    checked={pctValidation.values.caseVisibility === "Unlocked"}
                                                    onChange={pctValidation.handleChange}
                                                ></input>
                                                <label className="form-check-label" htmlFor="unlocked">Unlocked</label>
                                            </div>
                                            <div className="col-md-2 form-check">
                                                <input type="radio" className="form-check-input"
                                                    name="caseVisibility"
                                                    id="locked"
                                                    value="Locked"
                                                    checked={pctValidation.values.caseVisibility === "Locked"}
                                                    onChange={pctValidation.handleChange}
                                                ></input>
                                                <label className="form-check-label" htmlFor="locked">Locked</label>
                                            </div>
                                            <div className="col-md-2 form-check">
                                                <input type="radio" className="form-check-input"
                                                    name="caseVisibility"
                                                    id="allVisibility"
                                                    value="All"
                                                    checked={pctValidation.values.caseVisibility === "All"}
                                                    onChange={pctValidation.handleChange}
                                                ></input>
                                                <label className="form-check-label" htmlFor="allVisibility">All</label>
                                            </div>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3 col-form-label">
                                                Labels
                                            </label>
                                            <div className="col-md-2 form-check">
                                                <input type="radio" className="form-check-input"
                                                    name="entityStatus"
                                                    id="onlyNonHidden+"
                                                    value="ONH"
                                                    checked={pctValidation.values.entityStatus === "ONH"}
                                                    onChange={pctValidation.handleChange}
                                                ></input>
                                                <label className="form-check-label" htmlFor="onlyNonHidden+">Only non-hidden</label>
                                            </div>
                                            <div className="col-md-2 form-check" >
                                                <input type="radio" className="form-check-input"
                                                    name="entityStatus"
                                                    id="onlyStarred"
                                                    value="OS"
                                                    checked={pctValidation.values.entityStatus === "OS"}
                                                    onChange={pctValidation.handleChange}
                                                ></input>
                                                <label className="form-check-label" htmlFor="onlyStarred">Only starred</label>
                                            </div>
                                            <div className="col-md-2 form-check">
                                                <input
                                                    type="radio"
                                                    className="form-check-input"
                                                    id="onlyStarredHidden"
                                                    name="entityStatus"
                                                    value="OSNH"
                                                    checked={pctValidation.values.entityStatus === "OSNH"}
                                                    onChange={pctValidation.handleChange}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="onlyStarredHidden"
                                                >
                                                    Only starred and non-hidden
                                                </label>
                                            </div>
                                            <div className="form-check" style={{ flex: "0 0 13.33%", maxWidth: "12.5%" }}>
                                                <input type="radio" className="form-check-input"
                                                    name="entityStatus"
                                                    id="onlyHidden"
                                                    value="OH"
                                                    checked={pctValidation.values.entityStatus === "OH"}
                                                    onChange={pctValidation.handleChange}
                                                ></input>
                                                <label className="form-check-label" htmlFor="onlyHidden">Only hidden</label>
                                            </div>
                                            <div className="col-md-1 form-check" >
                                                <input type="radio" className="form-check-input"
                                                    name="entityStatus"
                                                    id="allLabels+"
                                                    value="ALL"
                                                    checked={pctValidation.values.entityStatus === "ALL"}
                                                    onChange={pctValidation.handleChange}
                                                ></input>
                                                <label className="form-check-label" htmlFor="allLabels+">All</label>
                                            </div>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3 col-form-label">
                                                Agent
                                            </label>
                                            <div className="col-md-2 form-check">
                                                <input type="radio" className="form-check-input"
                                                    name="hasRep"
                                                    id="allAgent+"
                                                    value="ALL"
                                                    checked={pctValidation.values.hasRep === "ALL"}
                                                    onChange={pctValidation.handleChange}
                                                ></input>
                                                <label className="form-check-label" htmlFor="allAgent+">All</label>
                                            </div>
                                            <div className="col-md-2 form-check">
                                                <input type="radio" className="form-check-input"
                                                    name="hasRep"
                                                    id="onlyWithAgent+"
                                                    value="YES"
                                                    checked={pctValidation.values.hasRep === "YES"}
                                                    onChange={pctValidation.handleChange}
                                                ></input>
                                                <label className="form-check-label" htmlFor="onlyWithAgent+">Only with agent</label>
                                            </div>
                                            <div className="col-md-2 form-check">
                                                <input type="radio" className="form-check-input"
                                                    name="hasRep"
                                                    id="onlyWithoutAgent+"
                                                    value="NO"
                                                    checked={pctValidation.values.hasRep === "NO"}
                                                    onChange={pctValidation.handleChange}
                                                ></input>
                                                <label className="form-check-label" htmlFor="onlyWithoutAgent+">Only without agent</label>
                                            </div>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3 col-form-label">
                                                Email sending
                                            </label>
                                            <div className="col-md-2 form-check">
                                                <input type="radio" className="form-check-input"
                                                    name="emailSent"
                                                    id="onlyNotSent+"
                                                    value="NO"
                                                    checked={pctValidation.values.emailSent === "NO"}
                                                    onChange={pctValidation.handleChange}
                                                ></input>
                                                <label className="form-check-label" htmlFor="onlyNotSent+">Only not sent</label>
                                            </div>
                                            <div className="col-md-2 form-check">
                                                <input type="radio" className="form-check-input"
                                                    name="emailSent"
                                                    id="onlySent+"
                                                    value="YES"
                                                    checked={pctValidation.values.emailSent === "YES"}
                                                    onChange={pctValidation.handleChange}
                                                ></input>
                                                <label className="form-check-label" htmlFor="onlySent+">Only sent</label>
                                            </div>
                                            <div className="col-md-2 form-check">
                                                <input type="radio" className="form-check-input"
                                                    name="emailSent"
                                                    id="allEmailSending+"
                                                    value="ALL"
                                                    checked={pctValidation.values.emailSent === "ALL"}
                                                    onChange={pctValidation.handleChange}
                                                ></input>
                                                <label className="form-check-label" htmlFor="allEmailSending+">All</label>
                                            </div>
                                        </Row>

                                        <Row className="mb-3">
                                            <span className="col-md-6 button-items">
                                                <Button
                                                    type="button"
                                                    color="primary"
                                                    outline
                                                    className="waves-effect waves-light"
                                                    onClick={() => {
                                                        pctValidation.setFieldValue("submitType", "saveSettings");
                                                        pctValidation.handleSubmit(pctValidation.values);
                                                    }}
                                                >
                                                    Save settings
                                                </Button>
                                                {
                                                    userActiveSub > 0 ?
                                                        <>
                                                            <Button
                                                                type="button"
                                                                color="primary"
                                                                outline
                                                                className="waves-effect waves-light"
                                                                id="btn_down-excel_1_1"
                                                                onClick={() => {
                                                                    pctValidation.setFieldValue("submitType", "downExcel");
                                                                    pctValidation.handleSubmit(pctValidation.values);
                                                                }}
                                                            >
                                                                Download Excel
                                                            </Button>
                                                            <UncontrolledTooltip
                                                                placement="top"
                                                                target="btn_down-excel_1_1">
                                                                Download details of all cases based on the filter as an Excel file limit 1,000 cases
                                                            </UncontrolledTooltip>
                                                        </>
                                                        :
                                                        <>
                                                            <Button
                                                                type="button"
                                                                color="disable"
                                                                outline
                                                                className="waves-effect waves-light"
                                                                id="btn_down-excel_1"
                                                            >
                                                                Download Excel
                                                            </Button>
                                                            <UncontrolledTooltip
                                                                placement="top"
                                                                target="btn_down-excel_1">
                                                                Contact us at global@wecrest.com to access all features.
                                                            </UncontrolledTooltip>
                                                        </>
                                                }
                                            </span>
                                            <Col md={3} style={{ paddingLeft: "1.3em" }}>
                                                <button
                                                    type="button"
                                                    className="waves-effect waves-light btn btn-primary"
                                                    style={{ width: "148.58px" }}
                                                    onClick={() => {
                                                        pctValidation.setFieldValue("submitType", "view");
                                                        pctValidation.setFieldValue("curPage", 1);
                                                        setCurPageInput(1);
                                                        pctValidation.handleSubmit(pctValidation.values);
                                                    }}
                                                >
                                                    View cases
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Collapse>
                        </Card>

                        {loading ? (
                            <LoadingModal
                                loading={loading}
                                setLoading={setPctLoading}
                            ></LoadingModal>
                        ) : null}

                        {success ? (
                            <SweetAlert
                                title={success}
                                timeout={2000}
                                showCloseButton={false}
                                showConfirm={false}
                                success
                                onConfirm={() => {
                                    dispatch(setPctSuccess(""));
                                }}
                            ></SweetAlert>
                        ) : null}

                        {sentSuccess ? (
                            <SweetAlert
                                title={success}
                                showCloseButton={false}
                                success
                                onConfirm={() => {
                                    dispatch(setPctSentSuccess(""));
                                }}
                            >
                                <div style={{ textAlign: 'left' }}>
                                    <div style={{ marginBottom: '1rem' }}>Emails have only been sent for entities with enabled contacts.</div>
                                    <div><label className='text-success' style={{ marginBottom: '1rem' }}>Sent: {numberWithCommas(sentCnt)} {sentCnt > 1 ? "emails" : "email"}</label></div>
                                    {disableEmails.length > 0 || unsubsEmails.length > 0 || sentIn5DaysEmails > 0 ?
                                        <>
                                            <div className='text-danger'>
                                                <label>Not sent</label><br />
                                                <ul>
                                                    {disableEmails.length > 0 ? <li>{numberWithCommas(disableEmails.length)} disabled {disableEmails.length > 1 ? "emails" : "email"}</li> : null}
                                                    {unsubsEmails.length > 0 ? <li>{numberWithCommas(unsubsEmails.length)} unsubscribed {unsubsEmails.length > 1 ? "emails" : "email"}</li> : null}
                                                    {sentIn5DaysEmails.length > 0 ? <li>{numberWithCommas(sentIn5DaysEmails.length)} {sentIn5DaysEmails.length > 1 ? "emails" : "email"} sent in the last 5 days</li> : null}
                                                </ul>
                                            </div>
                                        </>
                                        : null}
                                    {disableEmails.length ?
                                        <>
                                            <div>
                                                <label>Disabled</label><br />
                                                <ul>
                                                    {disableEmails.map((emailAddress, index) => {
                                                        return (
                                                            <li>{emailAddress}</li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                        </>
                                        : null}
                                    {unsubsEmails.length ?
                                        <>
                                            <div>
                                                <label>Unsubscribed</label><br />
                                                <ul>
                                                    {unsubsEmails.map((emailAddress, index) => {
                                                        return (
                                                            <li>{emailAddress}</li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                        </>
                                        : null}
                                    {sentIn5DaysEmails.length ?
                                        <>
                                            <div>
                                                <label>Sent in the last 5 days</label><br />
                                                <ul>
                                                    {sentIn5DaysEmails.map((emailAddress, index) => {
                                                        return (
                                                            <li>{emailAddress}</li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                        </>
                                        : null}
                                </div>
                            </SweetAlert>
                        ) : null}

                        {alertMsg !== "" ? (
                            <SweetAlert
                                onConfirm={() => {
                                    setAlertMsg("");
                                }}
                                onCancel={() => {
                                    setAlertMsg("");
                                }}
                            >
                                {alertMsg}
                            </SweetAlert>
                        ) : null}

                        {result !== -1 ? (
                            <SweetAlert
                                onConfirm={() => {
                                    dispatch(setPctResults(-1));
                                }}
                                title={errMsg[result]}
                            >
                                {result === 3 ? "You only pay the credits you need, there is no recurring charges. You can fully brand your emails and remove the WeCrest branding." : null}
                            </SweetAlert>
                        ) : null}

                        {upgradeAlertMessage.title != "" ? (
                            <SweetAlert
                                warning
                                showCancel
                                confirmBtnText="Refill"
                                cancelBtnText="No thanks"
                                confirmBtnBsStyle="wcdark"
                                cancelBtnBsStyle="secondary"
                                onConfirm={() => {
                                    window.location.href = "/membershipPlan";
                                }}
                                onCancel={() => {
                                    dispatch(setUpgradeAlertMessage({ title: "", text: "" }))
                                }}
                                title={upgradeAlertMessage.title}
                            >
                                {upgradeAlertMessage.text}
                            </SweetAlert>
                        ) : null}

                        {invoiceOverdueUnlockConfirmAlert.showYn ? (
                            <SweetAlert
                                warning
                                showCancel
                                confirmBtnText="Confirm"
                                cancelBtnText="Cancel"
                                confirmBtnBsStyle="wcdark"
                                cancelBtnBsStyle="secondary"
                                onConfirm={() => {
                                    setInvoiceOverdueUnlockConfirmAlert({type: "", showYn: false});
                                    if (invoiceOverdueUnlockConfirmAlert.type == "multiple") {
                                        setConfirmType("multipleUnlock");
                                        setConfirmMsg(<>
                                            Number of cases selected: {checkedLockedRowCount} <br />
                                            Unlock to view the details and send emails for this case.<br />
                                            You cannot unlock a case, if sending limit of 5 emails per case has been reached already today.
                                        </>);
                                        setConfirmBtnText("Confirm");
                                        setCancelBtnText("Cancel");
                                        setConfirmAlert(true);
                                    } else if (invoiceOverdueUnlockConfirmAlert.type.startsWith("unlock_")) {
                                        if (unlockCredit - unlockCnt > 0) {
                                            const sendCount = invoiceOverdueUnlockConfirmAlert.type.split("_")
                                            if (sendCount.length == 3 && parseInt(sendCount[2]) < 5) {
                                                setConfirmType(sendCount[0] + "_" + sendCount[1]);
                                                setConfirmMsg(<>
                                                    Unlock to view the details and send emails for this case.<br />
                                                    You cannot unlock a case, if sending limit of 5 emails per case has been reached already today.
                                                </>);
                                                setConfirmBtnText("Confirm");
                                                setCancelBtnText("Cancel");
                                                setConfirmAlert(true);
                                            } else {
                                            }
                                        } else {
                                            dispatch(setUpgradeAlertMessage({
                                                title: "Sorry, unfortunately you do not have any credits remaining. Get more credits and connect with more clients."
                                                , text: "You only pay the credits you need, there is no recurring charges. You can fully brand your emails and remove the WeCrest branding."
                                            }))
                                        }
                                    } else {
                                    }
                                }}
                                onCancel={() => {
                                    setInvoiceOverdueUnlockConfirmAlert({type: "", showYn: false})
                                }}
                                title={"Your 3-week grace period for the PCT subscription has ended."}
                            >
                                Unlocking this case will now consume a Free Credit. 
                                Please confirm if you would like to proceed.
                            </SweetAlert>
                        ) : null}

                        {confirmAlert ? (
                            <SweetAlert
                                showCancel
                                confirmBtnText={confirmBtnText}
                                cancelBtnText={cancelBtnText}
                                confirmBtnBsStyle="success"
                                cancelBtnBsStyle="danger"
                                onConfirm={() => {
                                    pctValidation.setFieldValue("submitType", confirmType);
                                    pctValidation.handleSubmit(pctValidation.values);
                                    setConfirmAlert(false);
                                }}
                                onCancel={() => setConfirmAlert(false)}
                            >
                                {confirmMsg}
                                {
                                    confirmType === 'multipleSend' ?
                                        <div className="d-flex gap-2">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="rdoSendTarget"
                                                    id="rdoSendTargetRep"
                                                    onClick={() => {
                                                        setSendTarget("REP");
                                                        setSendTargetGroupNo(0);
                                                    }}
                                                    value="REP"
                                                    checked={sendTarget === 'REP'}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="rdoSendTargetRep"
                                                >
                                                    Agents
                                                </label>
                                            </div>
                                            <div className="form-check" style={{ paddingLeft: '2em' }}>
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="rdoSendTarget"
                                                    id="rdoSendTargetHol"
                                                    onClick={() => {
                                                        setSendTarget("HOL");
                                                        setSendTargetGroupNo(0);
                                                    }}
                                                    value="HOL"
                                                    checked={sendTarget === 'HOL'}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="rdoSendTargetHol"
                                                >
                                                    Holders
                                                </label>
                                            </div>
                                        </div>
                                        : null
                                }
                            </SweetAlert>
                        ) : null}

                        <Modal
                            size="xl"
                            style={{ maxWidth: "1700px" }}
                            isOpen={modalContactsScreen}
                            toggle={() => { togContactsScreen(); }}
                        >
                            <div className="modal-body">
                                <button
                                    onClick={() => { togContactsScreen(); }}
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>

                                <ContactsDetails
                                    targetGroupNo={contactsTargetGroupNo.targetGroupNo}
                                    targetGroupCountry={contactsTargetGroupNo.targetGroupCountry}
                                    targetGroupAddress={contactsTargetGroupNo.targetGroupAddress}
                                    pctRepList={contactsRepList}
                                    field="Patent"
                                />
                            </div>
                        </Modal>

                        {previewEmail && Object.keys(previewEmail).length !== 0 ? (
                            <Modal
                                size="xl"
                                isOpen={true}
                                toggle={() => {
                                    dispatch(setPreviewPctEmail({}));
                                    setPdfActiveTab("");
                                }}
                            >
                                <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myExtraLargeModalLabel">
                                        <Table className="table mb-0">
                                            <tbody style={{ border: "none" }}>
                                                <tr>
                                                    <td style={{ width: "65px", padding: "0px", border: "none" }}>From</td>
                                                    <td style={{ padding: "0px", border: "none" }}>: {previewEmail.fromEmail ? previewEmail.fromEmail : ""}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ width: "65px", padding: "0px", border: "none" }}>To</td>
                                                    <td style={{ padding: "0px", border: "none" }}>: {previewEmail.toEmail ? previewEmail.toEmail : ""}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ width: "65px", padding: "0px", border: "none" }}>CC</td>
                                                    <td style={{ padding: "0px", border: "none" }}>: {previewEmail.emailCC ? previewEmail.emailCC : ""}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ width: "65px", padding: "0px", border: "none" }}>BCC</td>
                                                    <td style={{ padding: "0px", border: "none" }}>: {previewEmail.emailBCC ? previewEmail.emailBCC : ""}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ width: "65px", padding: "0px", border: "none" }}>Subject</td>
                                                    <td style={{ padding: "0px", border: "none" }}>: {previewEmail.subject ? previewEmail.subject : ""}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </h5>
                                    <button
                                        onClick={() => {
                                            // console.log("close preview!");
                                            dispatch(setPreviewPctEmail({}));
                                        }}
                                        type="button"
                                        className="close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <Card className="mb-2">
                                        <CardBody
                                            className="email-preview-content"
                                            style={{ overflow: "scroll", height: "500px" }}
                                            dangerouslySetInnerHTML={{
                                                __html: previewEmail.emailForm
                                                    ? previewEmail.emailForm
                                                    : null,
                                            }}
                                        ></CardBody>
                                    </Card>
                                    <Card className={previewPctPdfList && Object.entries(previewPctPdfList).length > 0 ? "mb-2" : "mb-0"}>
                                        {/* <Card className="mb-0"> */}
                                        <CardBody className="p-1">
                                            <Table className="table mb-0">
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            {Object.entries(previewPctPdfList).length > 0 ? (
                                                                <>
                                                                    &nbsp;
                                                                    {Object.entries(previewPctPdfList).sort((a, b) => a[0].localeCompare(b[0])).map(([key, pdf], index) => {
                                                                        return (
                                                                            // <a
                                                                            //     href={pdf}
                                                                            //     target="_blank"
                                                                            //     rel="noreferrer"
                                                                            // >
                                                                            //     <i className="mdi mdi-file-pdf text-danger font-size-22"></i>
                                                                            // </a>
                                                                            <Link to="#" onClick={(e) => {
                                                                                window.open(pdf, '_blank', 'noopener,noreferrer');
                                                                            }
                                                                            }>
                                                                                <i className="mdi mdi-file-pdf text-danger font-size-22" id={`pct_pdf_${key}`}></i>
                                                                                <UncontrolledTooltip placement="top" target={`pct_pdf_${key}`} className="domain-correct-tooltip">
                                                                                    {key}
                                                                                </UncontrolledTooltip>
                                                                            </Link>
                                                                        );
                                                                    })}
                                                                </>
                                                            ) : null}
                                                        </td>
                                                    </tr>
                                                    {previewEmail.attachFiles &&
                                                        previewEmail.attachFiles.length
                                                        ? previewEmail.attachFiles.map((attach, index) => {
                                                            return (
                                                                <tr>
                                                                    <td>{attach.fileName}</td>
                                                                </tr>
                                                            );
                                                        })
                                                        : null}
                                                </tbody>
                                            </Table>
                                        </CardBody>
                                    </Card>

                                    {
                                        Object.entries(previewPctPdfList).length > 0 ? (
                                            <Card className="mb-0">
                                                <CardBody
                                                    className="p-1 d-flex horizon-align-center"
                                                >
                                                    <Col>
                                                        <Row>
                                                            <Nav tabs className="d-flex flex-row" style={{marginLeft: "5px"}}>
                                                                {Object.entries(previewPctPdfList).sort((a, b) => a[0].localeCompare(b[0])).map(([key, pdf], index) => {
                                                                    return (
                                                                        <NavItem key={key}>
                                                                            <NavLink className={pdfActiveTab === key ? "nav-link active" : "nav-link"} style={{ cursor: "pointer" }}
                                                                                onClick={() => {
                                                                                    setPdfActiveTab(key);
                                                                                    // console.log("pdfActiveTab: " + pdfActiveTab);
                                                                                }}
                                                                            >
                                                                                {key}
                                                                            </NavLink>
                                                                        </NavItem>
                                                                    );
                                                                })}
                                                            </Nav>
                                                        </Row>
                                                        <TabContent
                                                            className="p-1 d-flex horizon-align-center"
                                                            style={{ overflow: "scroll", height: "500px" }}
                                                            activeTab={pdfActiveTab}
                                                        >
                                                            {Object.entries(previewPctPdfList).map(([key, pdf], index) => {
                                                                return (
                                                                    <TabPane key={key} tabId={key}>
                                                                        {pdfActiveTab === key && (
                                                                            <PDFDocumentWrapper>
                                                                                <Document
                                                                                    file={pdf}
                                                                                    onLoadSuccess={onDocumentLoadSuccess}
                                                                                >
                                                                                    {Array.from({ length: numPages }, (_, i) => (
                                                                                        <Page key={i} pageNumber={i + 1} />
                                                                                    ))}
                                                                                </Document>
                                                                            </PDFDocumentWrapper>
                                                                        )}
                                                                    </TabPane>
                                                                );
                                                            })}
                                                        </TabContent>
                                                    </Col>
                                                </CardBody>
                                            </Card>
                                        ) : null
                                    }
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            // console.log("close preview!");
                                            dispatch(setPreviewPctEmail({}));
                                        }}
                                        className="btn btn-secondary waves-effect"
                                        data-dismiss="modal"
                                    >
                                        Close
                                    </button>
                                </div>
                            </Modal>
                        ) : null}

                        <EditorModal
                            isOpenEditor={isOpenEditor}
                            isInitEditor={isInitEditor}
                            closeEditor={closeEditor}
                            loadedEditor={loadedEditor}
                            setLoadedEditor={setLoadedEditor}
                            editorModal={editorModal}
                            ref={editorModaRef}
                            emailType="PCT"
                            irNumber={pubNumber}
                            ftpDate={earliestPriorityDate}
                            crCode='00'
                            editedTemplateYn={editedTemplateYn}
                            inOutType='IN'
                        />

                        {
                            noticeStr && noticeStr !== "" ?
                                <Row>
                                    <Col lg={12}>
                                        <Card>
                                            <CardBody>
                                                <CardTitle className="title-muted mb-0">
                                                    <p style={{ isWhiteSpace: "pre" }}>{noticeStr}</p>
                                                    {pctSubscription != "N" && pctSubscription != "Unlimited" && (
                                                        <p style={{ color: '#75ba75' }}>Remaining credit: {pctUnlockCredit - pctUnlockCnt}</p>
                                                    )}
                                                    {
                                                        pctInfo && pctInfo.length > 0 && pctInfo.filter(fr => fr.checked).length > 0 ? (
                                                            <p style={{ whiteSpace: "pre", marginTop: "-10px", fontWeight: "500" }}>
                                                            Selected cases: {pctInfo.filter(pi => pi.checked).length}
                                                            </p>
                                                        ) : <></>
                                                    }
                                                    <Row className="mb-3">
                                                        <span className="col-md-8 button-items">
                                                            <Button
                                                                type="button"
                                                                color="primary"
                                                                outline
                                                                className="waves-effect waves-light"
                                                                id="btn_unlock"
                                                                onClick={() => {
                                                                    if (pctSubscriptionInvoiceOverdueYn == 'Y') {
                                                                        setInvoiceOverdueUnlockConfirmAlert({type: "multiple", showYn: true})
                                                                    } else if (caseChk()) {
                                                                        setConfirmType("multipleUnlock");
                                                                        setConfirmMsg(<>
                                                                            Number of cases selected: {checkedLockedRowCount} <br />
                                                                            Unlock to view the details and send emails for this case.<br />
                                                                            You cannot unlock a case, if sending limit of 5 emails per case has been reached already today.
                                                                        </>);
                                                                        setConfirmBtnText("Confirm");
                                                                        setCancelBtnText("Cancel");
                                                                        setConfirmAlert(true);
                                                                    }
                                                                }}
                                                            >
                                                                Unlock
                                                            </Button>
                                                            <UncontrolledTooltip
                                                                placeholder="top"
                                                                target="btn_unlock">
                                                                Unlock selected cases
                                                            </UncontrolledTooltip>
                                                            <Button
                                                                type="button"
                                                                color="primary"
                                                                outline
                                                                className="waves-effect waves-light"
                                                                id="btn_send"
                                                                onClick={() => {
                                                                    if (caseChk()) {
                                                                        setConfirmType("multipleSend")
                                                                        setConfirmMsg(
                                                                            <>
                                                                                <div className="mb-3" style={{ textAlign: "left" }}>
                                                                                    Emails will only be sent for entities, for which
                                                                                    <ul>
                                                                                        <li>email address has been entered</li>
                                                                                        <li>email subject and body are not empty</li>
                                                                                        <li>sending limit of 5 emails per case has not been reached</li>
                                                                                        <li>at least one saved email address has not been contacted within the past 5 days</li>
                                                                                    </ul>
                                                                                    If "Holders" is selected and multiple holders exist for a case, then emails will be sent to ALL holders, for which an email address has been entered. If this is not your intention, please cancel and process emails one by one.
                                                                                </div>
                                                                                <div className="mb-3" style={{ textAlign: "left" }}>Send emails to the selected</div>
                                                                            </>
                                                                        );
                                                                        setConfirmBtnText("Yes, send!");
                                                                        setCancelBtnText("Cancel");
                                                                        setSendTarget("REP");
                                                                        setSendTargetGroupNo(0);
                                                                        setConfirmAlert(true);
                                                                    }
                                                                }}
                                                            >
                                                                Send
                                                            </Button>
                                                            <UncontrolledTooltip placement="top" target="btn_send">
                                                                Send email to selected cases
                                                            </UncontrolledTooltip>
                                                            <Button
                                                                type="button"
                                                                color="primary"
                                                                outline
                                                                className="waves-effect waves-light"
                                                                id="btn_starOrUnstar"
                                                                onClick={() => {
                                                                    if (caseChk()) {
                                                                        //  console.log("caseCheck" + caseChk())
                                                                        setConfirmType(starOrUnstar);
                                                                        //   console.log("starOrUnstar: " + starOrUnstar)
                                                                        setConfirmMsg(
                                                                            "Are you sure you want to " + starOrUnstar.toLowerCase() + " all checked cases?"
                                                                        );
                                                                        setConfirmBtnText("Yes, " + starOrUnstar.toLowerCase());
                                                                        setCancelBtnText("Cancel");
                                                                        setConfirmAlert(true);
                                                                    }
                                                                }}
                                                            >
                                                                {starOrUnstar}
                                                            </Button>
                                                            <UncontrolledTooltip placement="top" target="btn_starOrUnstar">
                                                                {starOrUnstar} selected cases
                                                            </UncontrolledTooltip>
                                                            <Button
                                                                type="button"
                                                                color="primary"
                                                                outline
                                                                className="waves-effect waves-light"
                                                                id="btn_hideOrUnhide"
                                                                onClick={() => {
                                                                    if (caseChk()) {
                                                                        setConfirmType(hideOrUnhide);
                                                                        setConfirmMsg(
                                                                            "Are you sure you want to " + hideOrUnhide.toLowerCase() + " all checked cases?"
                                                                        );
                                                                        setConfirmBtnText("Yes, " + hideOrUnhide.toLowerCase());
                                                                        setCancelBtnText("Cancel");
                                                                        setConfirmAlert(true);
                                                                    }
                                                                }}
                                                            >
                                                                {hideOrUnhide}
                                                            </Button>
                                                            <UncontrolledTooltip placement="top" target="btn_hideOrUnhide">
                                                                {hideOrUnhide} selected cases
                                                            </UncontrolledTooltip>
                                                            {userActiveSub > 0 ?
                                                                <>
                                                                    <Button
                                                                        type="button"
                                                                        color="primary"
                                                                        outline
                                                                        className="waves-effect waves-light"
                                                                        id="btn_down_excel_2_1"
                                                                        onClick={() => {
                                                                            if (caseChk()) {
                                                                                pctValidation.setFieldValue("submitType", "multipleExcel")
                                                                                pctValidation.handleSubmit(pctValidation.values)
                                                                            }
                                                                        }}
                                                                    >
                                                                        Download Excel
                                                                    </Button>
                                                                    <UncontrolledTooltip placement="top" target="btn_down_excel_2_1">
                                                                        Download details of selected cases as an Excel file
                                                                    </UncontrolledTooltip>
                                                                    <Button
                                                                        type="button"
                                                                        color="primary"
                                                                        outline
                                                                        className="waves-effect waves-light"
                                                                        id="btn_down_pdf_2_1"
                                                                        onClick={() => {
                                                                            if (caseChk()) {
                                                                                pctValidation.setFieldValue("submitType", "multiplePdf")
                                                                                pctValidation.handleSubmit(pctValidation.values)
                                                                            }
                                                                        }}
                                                                    >
                                                                        Download PDF
                                                                    </Button>
                                                                    <UncontrolledTooltip placement="top" target="btn_down_pdf_2_1">
                                                                        Download details of selected cases as an PDF file
                                                                    </UncontrolledTooltip>
                                                                </>
                                                                :
                                                                <>
                                                                    <Button
                                                                        type="button"
                                                                        color="disable"
                                                                        outline
                                                                        className="waves-effect waves-light"
                                                                        id="btn_down_excel_2_2" >
                                                                        Download Excel
                                                                    </Button>
                                                                    <UncontrolledTooltip placement="top" target="btn_down_excel_2_2">
                                                                        Contact us at global@wecrest.com to access all features.
                                                                    </UncontrolledTooltip>
                                                                    <Button
                                                                        type="button"
                                                                        color="disable"
                                                                        outline
                                                                        className="waves-effect waves-light"
                                                                        id="btn_down_pdf_2_2"
                                                                    >
                                                                        Download PDF
                                                                    </Button>
                                                                    <UncontrolledTooltip placement="top" target="btn_down_pdf_2_2">
                                                                        Contact us at global@wecrest.com to access all features.
                                                                    </UncontrolledTooltip>
                                                                </>
                                                            }
                                                        </span>
                                                    </Row>
                                                </CardTitle>
                                                <div className="table-responsive">
                                                    <Table className="table mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ verticalAlign: "middle" }}>
                                                                    <input type="checkbox" checked={chkAllFlag} onClick={(e) => rowCheck("chkAll", e)}></input>
                                                                </th>
                                                                {columns && columns.length > 0 ?
                                                                    columns.map((column, index) => {
                                                                        return (
                                                                            <>
                                                                                <th key={column.id}
                                                                                    style={{
                                                                                        position: "relative",
                                                                                        whiteSpace: "pre-line",
                                                                                        textAlign: "center",
                                                                                        verticalAlign: "middle",
                                                                                        minWidth: column.minWidth
                                                                                    }}>
                                                                                    <span>
                                                                                        {column.id === "npeLikelihood" && (
                                                                                            <>
                                                                                                <span className="badge bg-primary rounded-pill">New</span>
                                                                                                {"\n"}
                                                                                            </>
                                                                                        )}
                                                                                        {column.label}
                                                                                        {column.tooltip && <i className="uil uil-question-circle font-size-18" id={column.id}></i>}
                                                                                        {column.id === "npeLikelihood" && pctValidation.values.npePredictionCr ?
                                                                                            `\n-${pctValidation.values.npePredictionCr}-` : null}
                                                                                    </span>
                                                                                    {
                                                                                        column.tooltip && (
                                                                                            <UncontrolledTooltip placement="top" target={column.id}>
                                                                                                {column.tooltip}
                                                                                            </UncontrolledTooltip>
                                                                                        )
                                                                                    }
                                                                                    {
                                                                                        column.asc && column.desc &&
                                                                                        (column.id !== "npeLikelihood" || pctValidation.values.npePredictionCr) && (
                                                                                            column.id === "npeLikelihood" ? (
                                                                                                <div style={{ position: "absolute", right: "2px", top: "50%", transform: "translateY(-50%)", display: "flex", flexDirection: "column", lineHeight: "18px" }}>
                                                                                                    <Link to='#' onClick={() => { viewPctNotifier(column.asc) }} className={column.ascActive}><i className="uil uil-angle-up font-size-18"></i></Link>
                                                                                                    <Link to='#' onClick={() => { viewPctNotifier(column.desc) }} className={column.descActive}><i className="uil uil-angle-down font-size-18"></i></Link>
                                                                                                </div>
                                                                                            ) : (
                                                                                                <div style={column.style}>
                                                                                                    <Link to='#' onClick={() => { viewPctNotifier(column.asc) }} className={column.ascActive}><i className="btn-asc-40 uil uil-angle-up font-size-18"></i></Link>
                                                                                                    <Link to='#' onClick={() => { viewPctNotifier(column.desc) }} className={column.descActive}><i className="btn-desc-40 uil uil-angle-down font-size-18"></i></Link>
                                                                                                </div>
                                                                                            )
                                                                                        )
                                                                                    }
                                                                                </th>
                                                                            </>
                                                                        )
                                                                    }) : null}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {pctInfo && pctInfo.length > 0 ?
                                                                pctInfo.map((pctItem, index) => {
                                                                    const maxRows = Math.max(pctItem?.holderList?.length || 1, 1)
                                                                    const repInfo = pctItem.repList?.find((repinfo) => repinfo.repSeq === '1')
                                                                        ?? pctItem.repList?.find((repinfo) => repinfo.repGroupNo !== null)
                                                                    return Array.from({ length: maxRows }).map((_, rowIndex) => <>
                                                                        <tr key={`${index}-${rowIndex}`} style={{ backgroundColor: pctItem.lastContactDate !== "0000-00-00" ? emailSentBgColor : null }}>
                                                                            {rowIndex === 0 ?
                                                                                <>

                                                                                    <td rowSpan={maxRows} style={{ verticalAlign: "middle" }}>
                                                                                        <input type="checkbox" onClick={(e) => rowCheck(index, e)} checked={pctItem.checked}></input>
                                                                                    </td>
                                                                                    <td rowSpan={maxRows} style={{ verticalAlign: "middle" }}
                                                                                        align="center">
                                                                                        <Row>
                                                                                            <div className="d-flex vertical-align-center horizon-align-center gap-2">
                                                                                                {pctItem.unlockYn === 'Y' || pctItem.premSubsYn === 'Unlimited' ?
                                                                                                    <>
                                                                                                        <Link to="#" onClick={() => {
                                                                                                            // console.log("dailyWcSendCount: " + pctItem.dailyWcSendCount)
                                                                                                            // console.log("lastContactDate: " + pctItem.lastContactDate)
                                                                                                            if (pctItem.dailyWcSendCount < 5) {
                                                                                                                openEditor(pctItem.pubNumber, pctItem.pctEmailTmpSetYn, pctItem.earlPriorityDate, Array.from(new Set((pctItem.pctPdfList || []).map(pdf => pdf.docType))))
                                                                                                            }
                                                                                                        }}
                                                                                                        >
                                                                                                            <i className={pctItem.dailyWcSendCount >= 5 ? "uil uil-envelope-edit font-size-22 text-danger" :
                                                                                                                pctItem.pctEmailTmpSetYn == 'Y' ? "uil uil-envelope-edit font-size-22 text-success" :
                                                                                                                    "uil uil-envelope-edit font-size-22 text-warning"
                                                                                                            } id={"editEmail_" + index} />
                                                                                                            <UncontrolledTooltip placement="top" target={"editEmail_" + index}>
                                                                                                                {pctItem.pctEmailTmpSetYn == 'Y' ? "Edited template" : "Default template"}
                                                                                                            </UncontrolledTooltip>
                                                                                                        </Link>
                                                                                                        <Link to="#"
                                                                                                            onClick={() => {
                                                                                                                if (pctItem.dailyWcSendCount < 5) {
                                                                                                                    if (pctItem.pctEmailTmpSetYn == 'Y'
                                                                                                                        && (pctSettings && pctSettings.senderEmailSeq > 0)) {
                                                                                                                        dispatch(previewPctEmail({ pctNotifierList: [pctItem] }))
                                                                                                                    } else if (pctItem.defaultPctEmlTmpSetYn == 'Y'
                                                                                                                        && (pctSettings && pctSettings.emailFormIdx > 0 && pctSettings.senderEmailSeq > 0)) {
                                                                                                                        dispatch(previewPctEmail({ pctNotifierList: [pctItem] }))
                                                                                                                    } else {
                                                                                                                        setAlertMsg(<span>Preview is not available because the email setting is not complete.<br /> Please edit the email settings in your <a href='/emailingSettings' className='a-href-underline'>settings</a>.</span>);
                                                                                                                    }
                                                                                                                }
                                                                                                            }}
                                                                                                        >
                                                                                                            <i className={pctItem.dailyWcSendCount < 5 ?
                                                                                                                "uil uil-file-search-alt font-size-22" : "uil uil-file-search-alt font-size-22 text-danger"
                                                                                                            } id={"previewEmail_" + index} />
                                                                                                            <UncontrolledTooltip placement="top" target={"previewEmail_" + index}>
                                                                                                                Preview email
                                                                                                            </UncontrolledTooltip>
                                                                                                        </Link>
                                                                                                    </>
                                                                                                    :
                                                                                                    <Link to="#" className={pctUnlockCredit - pctUnlockCnt > 0 || unlockCredit - unlockCnt > 0 ? pctItem.dailyWcSendCount == 0 ? "text-success" : pctItem.dailyWcSendCount < 3 ? "text-primary" : pctItem.dailyWcSendCount < 5 ? "text-warning" : "text-danger" : "text-danger"}
                                                                                                        onClick={() => {
                                                                                                            if (pctSubscriptionInvoiceOverdueYn == "Y") {
                                                                                                                setInvoiceOverdueUnlockConfirmAlert({type: "unlock_" + index + "_" + pctItem.dailyWcSendCount, showYn: true});
                                                                                                            } else if (pctUnlockCredit - pctUnlockCnt > 0 || unlockCredit - unlockCnt > 0) {
                                                                                                                if (pctItem.dailyWcSendCount < 5) {
                                                                                                                    setConfirmType("unlock_" + index);
                                                                                                                    setConfirmMsg(<>
                                                                                                                        Unlock to view the details and send emails for this case.<br />
                                                                                                                        You cannot unlock a case, if sending limit of 5 emails per case has been reached already today.
                                                                                                                    </>);
                                                                                                                    setConfirmBtnText("Confirm");
                                                                                                                    setCancelBtnText("Cancel");
                                                                                                                    setConfirmAlert(true);
                                                                                                                }
                                                                                                            } else {
                                                                                                                dispatch(setUpgradeAlertMessage({
                                                                                                                    title: "Sorry, unfortunately you do not have any credits remaining. Get more credits and connect with more clients."
                                                                                                                    , text: "You only pay the credits you need, there is no recurring charges. You can fully brand your emails and remove the WeCrest branding."
                                                                                                                }))
                                                                                                            }
                                                                                                        }}>
                                                                                                        <i className={"uil uil-lock-alt font-size-22"} id={"unlock_" + index}></i>
                                                                                                        <UncontrolledTooltip placement="top" target={"unlock_" + index}>
                                                                                                            {pctUnlockCredit - pctUnlockCnt > 0 || unlockCredit - unlockCnt > 0 ?
                                                                                                                pctItem.dailyWcSendCount === 5 ?
                                                                                                                    errMsg[5]
                                                                                                                    :
                                                                                                                    "Unlock to view the details and send emails for this case."
                                                                                                                :
                                                                                                                errMsg[3]
                                                                                                            }
                                                                                                        </UncontrolledTooltip>
                                                                                                    </Link>
                                                                                                }
                                                                                            </div>
                                                                                        </Row>
                                                                                    </td>
                                                                                </>
                                                                                : null}
                                                                            {rowIndex === 0 ?
                                                                                <td rowSpan={maxRows} style={{ verticalAlign: "middle" }}>
                                                                                    {repInfo?.repName ? (
                                                                                        <div style={{ width: "fit-content" }} class="d-flex flex-column align-items-start justify-content-center">
                                                                                            <Row>
                                                                                                <div className="d-flex align-items-center justify-content-center gap-2">
                                                                                                    <p className="multiline" id={"repInfo" + index + rowIndex}>
                                                                                                        {repInfo?.repCountry != "" ? `[${repInfo?.repCountry}]` : "" || ""}{" "}
                                                                                                        {repInfo?.repName || ""}{" "}
                                                                                                        {repInfo?.repAddress || ""}
                                                                                                    </p>
                                                                                                    <UncontrolledTooltip
                                                                                                        placement="top"
                                                                                                        target={"repInfo" + index + rowIndex}
                                                                                                    >
                                                                                                        {repInfo?.repCountry != "" ? `[${repInfo?.repCountry}]` : "" || ""}{" "}
                                                                                                        {repInfo?.repName || ""}{" "}
                                                                                                        {repInfo?.repAddress || ""}
                                                                                                    </UncontrolledTooltip>
                                                                                                    <Link to="#" id={"rep_copy_" + index + rowIndex}
                                                                                                        onClick={() => {
                                                                                                            const repCopyInfo = `${repInfo?.repCountry} ${repInfo?.repName} ${repInfo?.repAddress}`
                                                                                                            console.log(repCopyInfo)
                                                                                                            if (window.isSecureContext && navigator.clipboard) {
                                                                                                                console.log("secured copy >>> ", repCopyInfo)
                                                                                                                navigator.clipboard.writeText(repCopyInfo)
                                                                                                            } else {
                                                                                                                console.log("unsecured copy >>> ", repCopyInfo)
                                                                                                                unsecuredCopyToClipboard(repCopyInfo, "rep_copy_" + index + rowIndex)
                                                                                                            }
                                                                                                            showSuccessCopyToast();
                                                                                                        }}>
                                                                                                        <i className="uil uil-copy-alt font-size-22 text-secondary"></i>
                                                                                                    </Link>
                                                                                                    <UncontrolledTooltip placement="top" target={"rep_copy_" + index + rowIndex}>
                                                                                                        Copy agent's information to clipboard.
                                                                                                    </UncontrolledTooltip>
                                                                                                </div>
                                                                                            </Row>
                                                                                            {pctItem.unlockYn === 'Y' || pctItem.premSubsYn === 'Unlimited' ?
                                                                                                <Row>
                                                                                                    <div className="d-flex vertical-align-center gap-2">
                                                                                                        <Link to="#"
                                                                                                            className={repInfo?.repDbStatus === 'upToDate' ? "text-success" : repInfo?.repMemberConfirmEmlYn === 'Y' ? "text-primary"
                                                                                                                : repInfo?.repSuggestEmlYn === 'Y' ? "text-warning" : "text-danger"}
                                                                                                            onClick={() => {
                                                                                                                togContactsScreen(repInfo?.repGroupNo, pctItem.repList, repInfo?.repCountry, repInfo?.repAddress);
                                                                                                            }}
                                                                                                        >
                                                                                                            <i className="uil uil-at font-size-22" id={"contacts_rep_" + index + rowIndex}></i>
                                                                                                            <UncontrolledTooltip placement="top" target={"contacts_rep_" + index + rowIndex}>
                                                                                                                {repInfo?.repMemberConfirmEmlYn === 'Y' ? "Contacts of agent with member confirmations"
                                                                                                                    : repInfo?.repSuggestEmlYn === 'Y' ? "Contacts of agent with WeCrest suggestions"
                                                                                                                        : "Contacts of agent"}
                                                                                                            </UncontrolledTooltip>
                                                                                                        </Link>
                                                                                                        <Link to="#" className={repInfo?.repStarYn === 'Y' ? "text-warning" : "text-black-50"}
                                                                                                            onClick={() => {
                                                                                                                const _pctNotifier = []
                                                                                                                if (pctItem.unlockYn === 'Y' || pctItem.premSubsYn === 'Unlimited') {
                                                                                                                    _pctNotifier.push(pctItem)
                                                                                                                }
                                                                                                                if (repInfo?.repStarYn === 'Y') {
                                                                                                                    dispatch(unstarPctTarget(repInfo?.repGroupNo, _pctNotifier))
                                                                                                                } else {
                                                                                                                    dispatch(starPctTarget(repInfo?.repGroupNo, _pctNotifier))
                                                                                                                }
                                                                                                            }}>
                                                                                                            <i className="uil uil-star font-size-22" id={"Starred_rep_" + index + rowIndex}></i>
                                                                                                            <UncontrolledTooltip placement="top" target={"Starred_rep_" + index + rowIndex}>
                                                                                                                {repInfo?.repStarYn === 'Y' ? "Remove from starred" : "Star agent"}
                                                                                                            </UncontrolledTooltip>
                                                                                                        </Link>
                                                                                                        <Link to="#" className={repInfo?.repHideYn === 'Y' ? "text-danger" : "text-black-50"}
                                                                                                            onClick={() => {
                                                                                                                const _pctNotifier = []
                                                                                                                if (pctItem.unlockYn === 'Y' || pctItem.premSubsYn === 'Unlimited') {
                                                                                                                    _pctNotifier.push(pctItem)
                                                                                                                }
                                                                                                                if (repInfo?.repHideYn === 'Y') {
                                                                                                                    dispatch(unhidePctTarget(repInfo?.repGroupNo, _pctNotifier))
                                                                                                                } else {
                                                                                                                    dispatch(hidePctTarget(repInfo?.repGroupNo, _pctNotifier))
                                                                                                                }

                                                                                                            }}>
                                                                                                            <i className="uil uil-eye-slash font-size-22" id={"Hidden_rep_" + index + rowIndex}></i>
                                                                                                            <UncontrolledTooltip placement="top" target={"Hidden_rep_" + index + rowIndex}>
                                                                                                                {repInfo?.repHideYn === 'Y' ? "Unhide agent" : "Hide agent"}
                                                                                                            </UncontrolledTooltip>
                                                                                                        </Link>
                                                                                                        <Link to="#" className="text-black-50"
                                                                                                            onClick={() => {
                                                                                                                if (pctItem.dailyWcSendCount < 5) {
                                                                                                                    if (repInfo?.repDbStatus === "upToDate") {
                                                                                                                        if ((
                                                                                                                            pctItem.pctEmailTmpSetYn == 'Y' || pctItem.defaultPctEmlTmpSetYn == 'Y'
                                                                                                                        )
                                                                                                                            && pctItem.defaultSendEmailConfirmStatus == 'Confirmed') {
                                                                                                                            setConfirmType("send_" + index);
                                                                                                                            setSendTarget("REP");
                                                                                                                            setSendTargetGroupNo(repInfo?.repGroupNo);
                                                                                                                            setConfirmMsg("Are you sure you want to send this email?");
                                                                                                                            setConfirmBtnText("Yes, send!");
                                                                                                                            setCancelBtnText("Cancel");
                                                                                                                            setConfirmAlert(true);
                                                                                                                        } else {
                                                                                                                            setAlertMsg(<span>Send is not available because the email setting is not complete.<br /> Please edit the email settings in your <a href='/emailingSettings' className='a-href-underline'>settings</a>.</span>);
                                                                                                                        }
                                                                                                                    } else {
                                                                                                                        togContactsScreen(repInfo?.repGroupNo, pctItem.repList, repInfo?.repCountry, repInfo?.repAddress)
                                                                                                                    }
                                                                                                                }
                                                                                                            }}>
                                                                                                            <i className={pctItem.dailyWcSendCount < 5 ? "uil uil-message font-size-22" : "uil uil-message font-size-22 text-danger"} id={"send_rep_" + index + rowIndex}></i>
                                                                                                            <UncontrolledTooltip placement="top" target={"send_rep_" + index + rowIndex}>
                                                                                                                {pctItem.dailyWcSendCount < 5 ? repInfo?.repDbStatus === "new" ?
                                                                                                                    "To send an email to this entity, please save a contact with an email address."
                                                                                                                    : "Send to agent"
                                                                                                                    : errMsg[9]}
                                                                                                            </UncontrolledTooltip>
                                                                                                        </Link>
                                                                                                    </div>
                                                                                                </Row>
                                                                                                : null}
                                                                                        </div>
                                                                                    ) : null}
                                                                                </td>
                                                                                : null}
                                                                            <td class="d-flex align-items-center justify-content-center" style={{ verticalAlign: "middle" }}>
                                                                                {pctItem.holderList?.[rowIndex]?.holderName ? (
                                                                                    <div style={{ width: "fit-content" }} class="d-flex flex-column align-items-start justify-content-center">
                                                                                        <Row>
                                                                                            <div className="d-flex vertical-align-center gap-2">
                                                                                                <p className="multiline" id={"holInfo" + index + rowIndex}>
                                                                                                    {`[${pctItem.holderList?.[rowIndex]?.holCountry}]` || ""}{" "}
                                                                                                    {pctItem.holderList?.[rowIndex]?.holderName || ""}{" "}
                                                                                                    {pctItem.holderList?.[rowIndex]?.holAddress || ""}
                                                                                                </p>
                                                                                                <UncontrolledTooltip
                                                                                                    placement="top"
                                                                                                    target={"holInfo" + index + rowIndex}
                                                                                                >
                                                                                                    {`[${pctItem.holderList?.[rowIndex]?.holCountry}]` || ""}{" "}
                                                                                                    {pctItem.holderList?.[rowIndex]?.holderName || ""}{" "}
                                                                                                    {pctItem.holderList?.[rowIndex]?.holAddress || ""}
                                                                                                </UncontrolledTooltip>
                                                                                                <Link to="#" id={"hol_copy_" + index + rowIndex}
                                                                                                    onClick={() => {
                                                                                                        const holInfo = `${pctItem.holderList?.[rowIndex]?.holCountry} ${pctItem.holderList?.[rowIndex]?.holderName} ${pctItem.holderList?.[rowIndex]?.holAddress}`
                                                                                                        console.log(holInfo)
                                                                                                        if (window.isSecureContext && navigator.clipboard) {
                                                                                                            console.log("secured copy >>> ", holInfo)
                                                                                                            navigator.clipboard.writeText(holInfo)
                                                                                                        } else {
                                                                                                            console.log("unsecured copy >>> ", holInfo)
                                                                                                            unsecuredCopyToClipboard(holInfo, "hol_copy_" + index + rowIndex)
                                                                                                        }
                                                                                                        showSuccessCopyToast();
                                                                                                    }}>
                                                                                                    <i className="uil uil-copy-alt font-size-22 text-secondary"></i>
                                                                                                </Link>
                                                                                                <UncontrolledTooltip placement="top" target={"hol_copy_" + index + rowIndex}>
                                                                                                    Copy holder's information to clipboard.
                                                                                                </UncontrolledTooltip>
                                                                                            </div>
                                                                                        </Row>
                                                                                        {pctItem.unlockYn === 'Y' || pctItem.premSubsYn === 'Unlimited' ?
                                                                                            <Row>
                                                                                                <div className="d-flex vertical-align-center gap-2">
                                                                                                    <Link to="#"
                                                                                                        className={pctItem.holderList?.[rowIndex]?.holDbStatus === 'upToDate' ? "text-success" : pctItem.holderList?.[rowIndex]?.holMemberConfirmEmlYn === 'Y' ? "text-primary"
                                                                                                            : pctItem.holderList?.[rowIndex]?.holSuggestEmlYn === 'Y' ? "text-warning" : "text-danger"}
                                                                                                        onClick={() => {
                                                                                                            togContactsScreen(pctItem.holderList?.[rowIndex]?.holGroupNo, null, pctItem.holderList?.[rowIndex]?.holCountry, pctItem.holderList?.[rowIndex]?.holAddress);
                                                                                                        }}
                                                                                                    >
                                                                                                        <i className="uil uil-at font-size-22" id={"contacts_hol_" + index + rowIndex}></i>
                                                                                                        <UncontrolledTooltip placement="top" target={"contacts_hol_" + index + rowIndex}>
                                                                                                            {pctItem.holderList?.[rowIndex]?.holMemberConfirmEmlYn === 'Y' ? "Contacts of holder with member confirmations"
                                                                                                                : pctItem.holderList?.[rowIndex]?.holSuggestEmlYn === 'Y' ? "Contacts of holder with WeCrest suggestions"
                                                                                                                    : "Contacts of holder"}
                                                                                                        </UncontrolledTooltip>
                                                                                                    </Link>
                                                                                                    <Link to="#" className={pctItem.holderList?.[rowIndex]?.holStarYn === 'Y' ? "text-warning" : "text-black-50"}
                                                                                                        onClick={() => {
                                                                                                            const _pctNotifier = []
                                                                                                            if (pctItem.unlockYn === 'Y' || pctItem.premSubsYn === 'Unlimited') {
                                                                                                                _pctNotifier.push(pctItem)
                                                                                                            }
                                                                                                            if (pctItem.holderList?.[rowIndex]?.holStarYn === 'Y') {
                                                                                                                dispatch(unstarPctTarget(pctItem.holderList?.[rowIndex]?.holGroupNo, _pctNotifier))
                                                                                                            } else {
                                                                                                                dispatch(starPctTarget(pctItem.holderList?.[rowIndex]?.holGroupNo, _pctNotifier))
                                                                                                            }
                                                                                                        }}>
                                                                                                        <i className="uil uil-star font-size-22" id={"Starred_hol_" + index + rowIndex}></i>
                                                                                                        <UncontrolledTooltip placement="top" target={"Starred_hol_" + index + rowIndex}>
                                                                                                            {pctItem.holderList?.[rowIndex]?.holStarYn === 'Y' ? "Remove from starred" : "Star holder"}
                                                                                                        </UncontrolledTooltip>
                                                                                                    </Link>
                                                                                                    <Link to="#" className={pctItem.holderList?.[rowIndex]?.holHideYn === 'Y' ? "text-danger" : "text-black-50"}
                                                                                                        onClick={() => {
                                                                                                            const _pctNotifier = []
                                                                                                            if (pctItem.unlockYn === 'Y' || pctItem.premSubsYn === 'Unlimited') {
                                                                                                                _pctNotifier.push(pctItem)
                                                                                                            }
                                                                                                            if (pctItem.holderList?.[rowIndex]?.holHideYn === 'Y') {
                                                                                                                dispatch(unhidePctTarget(pctItem.holderList?.[rowIndex]?.holGroupNo, _pctNotifier))
                                                                                                            } else {
                                                                                                                dispatch(hidePctTarget(pctItem.holderList?.[rowIndex]?.holGroupNo, _pctNotifier))
                                                                                                            }
                                                                                                        }}>
                                                                                                        <i className="uil uil-eye-slash font-size-22" id={"Hidden_hol_" + index + rowIndex}></i>
                                                                                                        <UncontrolledTooltip placement="top" target={"Hidden_hol_" + index + rowIndex}>
                                                                                                            {pctItem.holderList?.[rowIndex]?.holHideYn === 'Y' ? "Unhide holder" : "Hide holder"}
                                                                                                        </UncontrolledTooltip>
                                                                                                    </Link>
                                                                                                    <Link to="#" className="text-black-50"
                                                                                                        onClick={() => {
                                                                                                            if (pctItem.dailyWcSendCount < 5) {
                                                                                                                if (pctItem.holderList?.[rowIndex]?.holDbStatus === "upToDate") {
                                                                                                                    if (
                                                                                                                        (pctItem.pctEmailTmpSetYn == 'Y' || pctItem.defaultPctEmlTmpSetYn == 'Y')
                                                                                                                        && pctItem.defaultSendEmailConfirmStatus == 'Confirmed'
                                                                                                                    ) {
                                                                                                                        setConfirmType("send_" + index);
                                                                                                                        setSendTarget("HOL");
                                                                                                                        setSendTargetGroupNo(pctItem.holderList?.[rowIndex]?.holGroupNo);
                                                                                                                        setConfirmMsg("Are you sure you want to send this email?");
                                                                                                                        setConfirmBtnText("Yes, send!");
                                                                                                                        setCancelBtnText("Cancel");
                                                                                                                        setConfirmAlert(true);
                                                                                                                    } else {
                                                                                                                        setAlertMsg(<span>Send is not available because the email setting is not complete.<br /> Please edit the email settings in your <a href='/emailingSettings' className='a-href-underline'>settings</a>.</span>);
                                                                                                                    }
                                                                                                                } else {
                                                                                                                    togContactsScreen(pctItem.holderList?.[rowIndex]?.holGroupNo, null, pctItem.holderList?.[rowIndex]?.holCountry, pctItem.holderList?.[rowIndex]?.holAddress)
                                                                                                                }
                                                                                                            }
                                                                                                        }}>
                                                                                                        <i className={pctItem.dailyWcSendCount < 5 ? "uil uil-message font-size-22" : "uil uil-message font-size-22 text-danger"} id={"send_hol_" + index + rowIndex}></i>
                                                                                                        <UncontrolledTooltip placement="top" target={"send_hol_" + index + rowIndex}>

                                                                                                            {pctItem.dailyWcSendCount < 5 ? pctItem.holderList?.[rowIndex]?.holDbStatus === "new" ?
                                                                                                                "To send an email to this entity, please save a contact with an email address."
                                                                                                                : "Send to holder"
                                                                                                                : errMsg[9]}
                                                                                                        </UncontrolledTooltip>
                                                                                                    </Link>
                                                                                                </div>
                                                                                            </Row>
                                                                                            : null}
                                                                                    </div>
                                                                                ) : null}
                                                                            </td>
                                                                            {rowIndex === 0 ?
                                                                                <>
                                                                                    <td rowSpan={maxRows} style={{ verticalAlign: "middle", textAlign: "center" }}>
                                                                                        <Row>
                                                                                            <div className="d-flex vertical-align-center horizon-align-center">
                                                                                                {/* {
                                                                                                    pctItem.unlockYn === 'Y' || pctItem.premSubsYn === 'Unlimited' ?
                                                                                                        (pctItem.pctPdfList?.[0]?.pdfStorageUrl) ?
                                                                                                            <a href={pctItem.pctPdfList[0].pdfStorageUrl} target="_blank" rel="noreferrer" className="text-primary text-decoration-underline">
                                                                                                                {pctItem.intAppNo}
                                                                                                            </a>
                                                                                                            :
                                                                                                            <p>{pctItem.intAppNo}</p>
                                                                                                        :
                                                                                                        <p>
                                                                                                            {pctItem.intAppNo}
                                                                                                        </p>
                                                                                                } */}
                                                                                                <span>
                                                                                                    {pctItem.intAppNo}
                                                                                                </span>
                                                                                            </div>
                                                                                        </Row>
                                                                                        {(pctItem.unlockYn === 'Y' || pctItem.premSubsYn === 'Unlimited') && pctItem.pctPdfList && pctItem.pctPdfList.length > 0 ?
                                                                                            <Row className="mt-2 mb-1">
                                                                                                <div style={{display: "flex", gap: "2px", justifyContent: "center", alignItems: "center"}} className="vertical-align-center">
                                                                                                    {
                                                                                                        pctItem.pctPdfList.find(pdf => pdf.pdfStorageUrl && pdf.pdfStorageUrl !== "" && pdf.docType === "IB301") && (
                                                                                                            <div 
                                                                                                             style={
                                                                                                              (["IB301", "RO101"].every(docType => pctItem.pctPdfList.find(pdf => pdf.pdfStorageUrl && pdf.pdfStorageUrl !== "" && pdf.docType === docType))) ?
                                                                                                                {
                                                                                                                display: "flex", 
                                                                                                                flexDirection: "column", 
                                                                                                                gap: "3px",
                                                                                                                marginRight: "4px",
                                                                                                                paddingRight: "5px",
                                                                                                                borderRight: "1px solid #8894a0"
                                                                                                                } :
                                                                                                                    {
                                                                                                                    display: "flex", 
                                                                                                                    flexDirection: "column", 
                                                                                                                    gap: "3px"
                                                                                                                    }
                                                                                                             }
                                                                                                            >
                                                                                                                {/* {pctItem.pctPdfList.filter(pdf => pdf.pdfStorageUrl && pdf.pdfStorageUrl !== "" && pdf.docType === "IB301").map((pdf, pdfIndex) => { */}
                                                                                                                    {/* return ( */}
                                                                                                                        <Link to="#"
                                                                                                                            className="d-flex justify-content-center vertical-align-center"
                                                                                                                            onClick={() => {
                                                                                                                                window.open(
                                                                                                                                    pctItem.pctPdfList
                                                                                                                                        .filter(pdf => pdf.pdfStorageUrl && 
                                                                                                                                            pdf.pdfStorageUrl !== "" &&
                                                                                                                                             pdf.docType === "IB301"
                                                                                                                                        ).sort((a, b) => b.pdfSeq-a.pdfSeq)[0].pdfStorageUrl
                                                                                                                                , "_blank")
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            <i className="mdi mdi-file-pdf text-danger font-size-17"
                                                                                                                            ></i>
                                                                                                                            <span className="ms-1 text-primary" style={{ fontSize: "13px" }}>IB/301</span>
                                                                                                                        </Link>
                                                                                                                    {/* ) */}
                                                                                                                {/* })} */}
                                                                                                            </div>
                                                                                                        )
                                                                                                    }
                                                                                                    {
                                                                                                        pctItem.pctPdfList.find(pdf => pdf.pdfStorageUrl && pdf.pdfStorageUrl !== "" && pdf.docType === "RO101") && (
                                                                                                            <div style={{display: "flex", flexDirection: "column", gap: "3px"}}>
                                                                                                                {/* {pctItem.pctPdfList.filter(pdf => pdf.pdfStorageUrl && pdf.pdfStorageUrl !== "" && pdf.docType === "RO101").map((pdf, pdfIndex) => { */}
                                                                                                                    {/* return ( */}
                                                                                                                        <Link to="#"
                                                                                                                            className="d-flex justify-content-center vertical-align-center"
                                                                                                                            onClick={() => {
                                                                                                                                window.open(pctItem.pctPdfList
                                                                                                                                        .filter(pdf => pdf.pdfStorageUrl && 
                                                                                                                                            pdf.pdfStorageUrl !== "" &&
                                                                                                                                             pdf.docType === "RO101"
                                                                                                                                        ).sort((a, b) => a.pdfSeq-b.pdfSeq)[0].pdfStorageUrl, "_blank")
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            <i className="mdi mdi-file-pdf text-danger font-size-17"
                                                                                                                            ></i>
                                                                                                                            <span className="ms-1 text-primary" style={{ fontSize: "13px" }}>RO/101</span>
                                                                                                                        </Link>
                                                                                                                    {/* ) */}
                                                                                                                {/* })} */}
                                                                                                            </div>
                                                                                                            
                                                                                                        )
                                                                                                    }
                                                                                                </div>
                                                                                            </Row>
                                                                                            : null}
                                                                                        {pctItem.unlockYn === 'Y' || pctItem.premSubsYn === 'Unlimited' ?
                                                                                            <Row>
                                                                                                <div className="d-flex horizon-align-center vertical-align-center gap-2">
                                                                                                    <Link to="#"
                                                                                                        className={pctItem.starYn === "Y" ? "text-warning" : null}
                                                                                                        onClick={() => {
                                                                                                            const _pctNotifier = []
                                                                                                            _pctNotifier.push(pctItem)
                                                                                                            if (pctItem.starYn === "Y") {
                                                                                                                dispatch(multipleUnstarPct(_pctNotifier))
                                                                                                            } else {
                                                                                                                dispatch(multipleStarPct(_pctNotifier))
                                                                                                            }
                                                                                                        }}
                                                                                                    >
                                                                                                        <i className="uil uil-star font-size-22" id={"Starred_case_" + index + rowIndex}
                                                                                                        ></i>
                                                                                                        <UncontrolledTooltip placement="top" target={"Starred_case_" + index + rowIndex}>
                                                                                                            {pctItem.starYn === "Y" ? "Remove from starred" : "Star case"}
                                                                                                        </UncontrolledTooltip>
                                                                                                    </Link>
                                                                                                    <Link to="#" className={pctItem.hideYn === "Y" ? "text-danger" : null}
                                                                                                        onClick={() => {
                                                                                                            if (pctItem.hideYn === "Y") {
                                                                                                                dispatch(multipleUnhidePct([pctItem]))
                                                                                                            } else {
                                                                                                                dispatch(multipleHidePct([pctItem]))
                                                                                                            }
                                                                                                        }}>
                                                                                                        <UncontrolledTooltip placement="top" target={"Hidden_case_" + index + rowIndex}>
                                                                                                            {pctItem.hideYn === "Y" ? "Unhide case" : "Hide case"}
                                                                                                        </UncontrolledTooltip>
                                                                                                        <i className="uil uil-eye-slash font-size-22" id={"Hidden_case_" + index + rowIndex}></i>
                                                                                                    </Link>
                                                                                                </div>
                                                                                            </Row>
                                                                                            : null}
                                                                                    </td>
                                                                                    <td rowSpan={maxRows} style={{ verticalAlign: "middle", textAlign: "center" }}>
                                                                                        {rowIndex === 0 ? formatPctDbDate(pctItem.earlPriorityDate) : null}
                                                                                    </td>
                                                                                    <td rowSpan={maxRows} style={{ verticalAlign: "middle", textAlign: "center" }}>
                                                                                        {rowIndex === 0 ? formatPctDbDate(pctItem.intFilDate) : null}
                                                                                    </td>
                                                                                    <td rowSpan={maxRows} style={{ verticalAlign: "middle", textAlign: "center" }}>
                                                                                        {rowIndex === 0 ? formatPctDbDate(pctItem.pubDate) : null}
                                                                                    </td>
                                                                                    <td rowSpan={maxRows} style={{ verticalAlign: "middle", textAlign: "center" }}>
                                                                                        {rowIndex === 0 ? `${pctItem.npeOfficeCodes}` : "-"}
                                                                                    </td>
                                                                                    <td rowSpan={maxRows} style={{ verticalAlign: "middle", textAlign: "center" }}>
                                                                                        {rowIndex === 0 ?
                                                                                            (pctItem.npePredictionNpeCount != null && pctItem.npePredictionSampleSize ?
                                                                                                <>
                                                                                                    {Math.round((pctItem.npePredictionNpeCount / pctItem.npePredictionSampleSize) * 100)}%
                                                                                                    <br />
                                                                                                    <span style={{ fontSize: "smaller" }}>
                                                                                                        ({pctItem.npePredictionNpeCount}/{pctItem.npePredictionSampleSize} cases)
                                                                                                    </span>
                                                                                                </>
                                                                                                : "-")
                                                                                            : null}
                                                                                    </td>
                                                                                    <td rowSpan={maxRows} style={{ verticalAlign: "middle", textAlign: "center" }}>
                                                                                        {rowIndex === 0 ? `${pctItem.dailyWcSendCount} (${pctItem.wcSendCount})` : null}
                                                                                    </td>
                                                                                </>
                                                                                : null}
                                                                        </tr>
                                                                    </>
                                                                    )
                                                                })
                                                                : null}
                                                        </tbody>
                                                    </Table>
                                                </div>

                                                <WeCrestPagination
                                                    viewList={viewList}
                                                    pageSize={pctValidation.values.pageSize}
                                                    curPage={pctValidation.values.curPage}
                                                    totalPage={pctInfoTotalPages}
                                                    curPageInput={curPageInput}
                                                    setCurPageInput={setCurPageInput}
                                                    pageSizeList={[50, 100, 250, 500, 1000]}
                                                />
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                :
                                null
                        }
                    </div>
                </div>
            </Form>
        </React.Fragment>
    )
}

export default PCTNotifier;